<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >

            <el-form-item label="订单编号">
                <el-input v-model="queryForm.orderNumber" placeholder="请输入订单编号" style="width: 200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="订单类型">
                <el-select v-model="queryForm.orderType" placeholder="请选择订单类型" size="small" clearable style="width: 200px">
                    <el-option v-for="orderType in orderTypeList" :key="orderType.key" :label="orderType.value" :value="orderType.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单状态">
                <el-select v-model="queryForm.orderStatus" placeholder="请选择订单状态" size="small" clearable style="width: 200px">
                    <el-option
                        v-for="orderStatus in orderStatusList"
                        :key="orderStatus.key"
                        :label="orderStatus.value"
                        :value="orderStatus.key"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品名称">
                <el-input v-model="queryForm.checkName" placeholder="请输入商品名称" style="width: 200px" size="small"></el-input>
            </el-form-item>
			<el-form-item label="用户账号">
			    <el-input v-model="queryForm.userName" placeholder="请输入用户名称" style="width: 200px" size="small"></el-input>
			</el-form-item>
            <el-form-item label="实付金额">
                <el-input v-model="queryForm.minOrderPrice" placeholder="请输入起始价格" style="width: 200px" size="small"></el-input
                ><br />
                <el-input v-model="queryForm.maxOrderPrice" placeholder="请输入结束价格" style="width: 200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="收货姓名">
                <el-input v-model="queryForm.orderContact" placeholder="请输入收货姓名" style="width: 200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="联系手机">
                <el-input v-model="queryForm.orderTel" placeholder="请输入联系手机" style="width: 200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="下单时间">
                <el-date-picker
                    v-model="addtimeRange"
                    style="width: 200px"
                    type="datetimerange"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="付款时间">
                <el-date-picker
                    v-model="paytimeRange"
                    style="width: 200px"
                    type="datetimerange"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="发货时间">
                <el-date-picker
                    v-model="delivertimeRange"
                    style="width: 200px"
                    type="datetimerange"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
            </el-form-item>

            <el-form-item label="完成时间">
                <el-date-picker
                    v-model="finishtimeRange"
                    style="width: 200px"
                    type="datetimerange"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
            </el-form-item>
			<el-form-item label="取消时间">
			    <el-date-picker
			        v-model="canceltimeRange"
                    style="width: 200px"
			        type="datetimerange"
			        size="small"
			        format="yyyy-MM-dd HH:mm:ss"
			        value-format="yyyy-MM-dd HH:mm:ss"
			        range-separator="-"
			        start-placeholder="开始时间"
			        end-placeholder="结束时间"
			    >
			    </el-date-picker>
			</el-form-item>
            <el-form-item label="物流公司">
                <el-input v-model="queryForm.freightName" placeholder="请输入物流公司" style="width: 200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="运货单号">
                <el-input v-model="queryForm.freightNumber" placeholder="请输入运货单号" style="width: 200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="支付方式">
                <el-select v-model="queryForm.payType" style="width: 200px" placeholder="请选择支付方式" clearable size="small">
                    <el-option v-for="pageType in payTypeList" :key="pageType.key" :label="pageType.value" :value="pageType.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支付编号">
                <el-input v-model="queryForm.payNo" placeholder="请输入支付编号" style="width: 200px" size="small"></el-input>
            </el-form-item>
            <el-form-item v-if="showShop" label="所属店铺">
                <GridSelectShop
                    style="width: 200px"
                    title="选择所属店铺"
                    labelName="shopName"
                    labelValue="id"
                    :value="queryForm.shopId"
                    :limit="1"
                    size="small"
                    @getValue="getValueShopId"
                    :columns="SHOP_code"
                    :searchs="SHOP_search"
                    dataListUrl="/mall/shop/findList"
                    entityBeanName="mallShop"
                    queryEntityUrl="/mall/shop/get"
                >
                </GridSelectShop>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopProductOrderList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class='content'>
            <div class="page-tool-bar">
                <div class="el-btn-group" style="display: flex">
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopProductOrder(null)"
                    >删除</el-button
                    >
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span class="icon-box" title="导入数据" @click="isImport">
                        <Icon color="#606266">
                            <ArrowExportUp24Regular />
                        </Icon>
                    </span>

                    <span title="导出数据" class="icon-box" @click="exportShopProductOrderList">
                        <Icon color="#606266">
                            <ArrowDownload24Regular />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshShopProductOrderList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <div class="page-content">
                <!-- 列表数据 -->
                <el-table
                    :data="shopProductOrderList"
                    row-key="id"
                    size="small"
                    height="100%"
                    ref="multipleTable"
                    :header-row-style="{ height: '10px' }"
                    :header-cell-style="{ padding: '10px' }"
                    :row-style="{ height: '9px' }"
                    :cell-style="{ padding: '0px' }"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column align="center" type="selection" width="60"> </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" label="商品信息" width="822">
                        <template slot-scope="scope">
                            <div class="temp">
                                <el-table
                                    :header-cell-style="{ textAlign: 'center' }"
                                    :cell-style="{ textAlign: 'center' }"
                                    :data="scope.row.shopOrderSkuList"
                                    row-key="id"
                                    size="small"
                                    style="margin-top: 0"
                                    height="100%"
                                >
                                    <!-- <el-table-column align="center" type="selection" :selectable="selectable" width="60"> </el-table-column> -->
                                    <el-table-column :show-overflow-tooltip="true" align="center" label="商品图片" width="100">
                                        <template slot-scope="scope">
                                            <el-image
                                                v-if="scope.row.shopProduct && scope.row.shopProduct.productPic"
                                                @click='updateSrcList(scope.row.shopProduct.productPic)'
                                                style="width: 30px; height: 30px"
                                                :src="scope.row.shopProduct.productPic"
                                                :preview-src-list="srcList"
                                            > </el-image>
                                            <el-image
                                                v-else-if="scope.row.skuPic"
                                                @click='updateSrcList(scope.row.skuPic)'
                                                style="width: 30px; height: 30px"
                                                :src="scope.row.skuPic"
                                                :preview-src-list="srcList"
                                            > </el-image>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        :show-overflow-tooltip="true"
                                        align="left"
                                        prop="shopProduct.productName"
                                        label="商品名称"
                                        width="280"
                                    >
                                        <template scope='scope'>
                                            <span v-if='scope.row.shopProduct && scope.row.shopProduct.productName'>{{scope.row.shopProduct.productName}}</span>
                                            <span v-else-if='scope.row.productName'>{{scope.row.productName}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        :show-overflow-tooltip="true"
                                        align="left"
                                        prop="skuKvNames"
                                        label="商品规格"
                                        width="100"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        :show-overflow-tooltip="true"
                                        align="left"
                                        prop="skuPrice"
                                        label="商品价格"
                                        width="100"
                                    >
                                        <template scope='scope'>
                                            ￥{{scope.row.skuPrice}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        :show-overflow-tooltip="true"
                                        align="left"
                                        prop="orderSize"
                                        label="商品数量"
                                        width="100"
                                    >
                                        <template scope='scope'>
                                            {{scope.row.orderSize}}件
                                        </template>
                                    </el-table-column>
                                    <el-table-column :show-overflow-tooltip="true" align="center" label="商品状态" width="120">
                                        <template slot-scope="scope">
                                            <div>
                                                <div
                                                    v-if="scope.row.returnWay == 1 && scope.row.returnStatus == 1"
                                                    @click="retreat(scope.row)"
                                                    style="margin-bottom: 4px; width: 85px; height: 20px;padding: 0;"
                                                    type="primary"
                                                    size="small"
                                                >申请退款中</div>
                                                <div
                                                    v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 1"
                                                    @click="retreat(scope.row)"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >申请退货/退款中</div>
                                                <div
                                                    v-if="scope.row.returnWay == 1 && scope.row.returnStatus == 2"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >拒绝退款</div>
                                                <div
                                                    v-if="scope.row.returnWay == 1 && scope.row.returnStatus == 5"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >同意退款</div>
                                                <div
                                                    v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 2"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >拒绝退货/退款</div>
                                                <div
                                                    v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 3"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >待补充运单号</div>
                                                <div
                                                    v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 4"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    @click="retreat(scope.row)"
                                                    type="primary"
                                                    size="small"
                                                >已补充运单号</div>
                                                <div
                                                    v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 5"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >同意退货/退款</div>
                                                <div
                                                    @click="afterSalesRecord(scope.row.id)"
                                                    v-if="scope.row.returnWay"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >售后记录</div>
                                                <div
                                                    v-if="!scope.row.shopProduct"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px;color:red"
                                                    type="primary"
                                                    size="small"
                                                >[商品已下架]</div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column align="center" label="物流信息" width="150">
                                        <template slot-scope="scop">
                                            <div class="operation" v-show="scop.row.shopOrderDelivery !== null">
                                                <div @click="checkShopProductOrders(scop.row.id)">
                                                    <Icon size="16">
                                                        <Eye24Regular />
                                                    </Icon>
                                                    <span class="operation-label">查看物流</span>
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column> -->
                                </el-table>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="left" label="用户" width="150">
                        <template slot-scope="scope">
                            <div v-if="scope.row.user">
                                <div style="text-align: left">账号：{{ scope.row.user.userName ? scope.row.user.userName : '--' }}</div>
                                <div style="text-align: left">昵称：{{scope.row.user.userNickname ? scope.row.user.userNickname : '--' }}</div>
                                <div style="text-align: left">姓名：{{ scope.row.user.userRealname ? scope.row.user.userRealname : '--'}}</div>
                                <div style="text-align: left">手机：{{ scope.row.user.userMobile ? scope.row.user.userMobile : '--' }}</div>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column :show-overflow-tooltip="true" align="left" label="收件信息" width="150">
                        <template slot-scope="scope">
                            <div style="text-align: left">收货姓名：{{ scope.row.orderContact }}</div>
                            <div style="text-align: left">收货电话：{{ scope.row.orderTel }}</div>
                            <div style="text-align: left">收货地址：{{ scope.row.orderAddress }}</div>
                            <div style="text-align: left">下单备注：{{ scope.row.orderRemarks }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="left" label="订单信息" width="200">
                        <template slot-scope="scope">
                            <div style="text-align: left">订单编号：{{ scope.row.orderNumber }}</div>
                            <div style="text-align: left" v-if="scope.row.outTradeNo">支付编号：{{ scope.row.outTradeNo }}</div>
                            <div style="text-align: left">下单时间：{{ scope.row.orderAddtime }}</div>
                            <div style="text-align: left" v-if="scope.row.orderPaytime">支付时间：{{ scope.row.orderPaytime }}</div>
                            <div style="text-align: left" v-if="scope.row.orderDelivertime">发货时间：{{ scope.row.orderDelivertime }}</div>
                            <div style="text-align: left" v-if="scope.row.orderConfirmtime">收货时间：{{ scope.row.orderConfirmtime }}</div>
                            <div style="text-align: left" v-if="scope.row.orderCommenttime">评价时间：{{ scope.row.orderCommenttime }}</div>
                            <div style="text-align: left" v-if="scope.row.orderCanceltime">取消时间：{{ scope.row.orderCanceltime }}</div>
                            <div style="text-align: left" v-if="scope.row.orderFinishtime">完成时间：{{ scope.row.orderFinishtime }}</div>
                            <div style="text-align: left" v-if="scope.row.orderDeletetime">删除时间：{{ scope.row.orderDeletetime }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" prop="orderSize" label="订购数量" width="100">
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" prop="orderPrice" label="订购价格" width="100">
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" prop="actualPrice" label="实付金额" width="100">
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" prop="orderScore" label="订单积分" width="100">
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" prop="productType" label="商品类型" width="100">
                        <template slot-scope="scope">
                            <el-tag type="danger" effect="light" v-if='scope.row.productType'>{{ getEnumLists(scope.row.productType,'productType') }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" prop="orderType" label="订单类型" width="100">
                        <template slot-scope="scope">
                            <el-tag type="danger" effect="light" v-if='scope.row.orderType'>{{ getEnumLists(scope.row.orderType) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" prop="orderSource" label="订单来源" width="100">
                        <template slot-scope="scope">
                            <el-tag type="danger" effect="light" v-if='scope.row.orderSource'>{{ getEnumLists(scope.row.orderSource, 'orderSource') }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" prop="payType" label="支付类型" width="100">
                        <template slot-scope="scope">
                            <el-tag type="danger" effect="light" v-if='scope.row.payType'>{{ getPayTypeLabel(scope.row.payType) }} {{ scope.row.payType == 1 ? '(' + getEnumLists(scope.row.currencyType, 'currencyType') + ')' : '' }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" label="订单状态" width="100">
                        <template slot-scope="scope">
                            <div style="color: red">
                                {{returnGetEnums(Number(scope.row.orderType),Number(scope.row.orderStatus))}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" label="配送方式" width="100">>
                        <template slot-scope="scope">
                            <div style="color: red">
                                {{returnItems(scope.row.orderType,scope.row.deliverMethod)}}
                            </div>
                        </template>
                    </el-table-column>
					<el-table-column v-if="showShop" :show-overflow-tooltip="true" align="center" label="所属店铺" width="100">
					    <template slot-scope="scope">
					        <div v-if="scope.row.shop">{{ scope.row.shop.shopName }}</div>
					    </template>
					</el-table-column>
                    <el-table-column fixed="right" align="center" label="操作" width="250">
                        <template slot-scope="scop">
                            <div class="operation">
                                <!-- <div v-show="scop.row.orderStatus == 2" @click="deliverGoods(scop.row)">
                                    <span class="operation-label">发货</span>
                                </div> -->
                                <div @click="getBtnMethod(scop.row)">
                                    <span class="operation-label">{{getBtnName(scop.row.orderType,scop.row.orderStatus)}}</span>
                                </div>
                                <!--div @click="editShopProductOrder(scop.row.id)">
                                    <Icon size="16">
                                        <Edit24Regular />
                                    </Icon>
                                    <span class="operation-label">修改</span>
                                </div-->
                                <div @click="checkShopProductOrder(scop.row.id)">
                                    <Icon size="16">
                                        <Eye24Regular />
                                    </Icon>
                                    <span class="operation-label">查看</span>
                                </div>
                                <el-dropdown size="small">
                                <span class="el-dropdown-link">
                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item style='color:#409EFF'>
                                            <div
                                                    v-show="
                                                        scop.row.orderStatus == 3
                                                    "
                                                    @click="deliverGoods(scop.row)"
                                                >
                                                    <Icon size="16">
                                                        <Edit24Regular />
                                                    </Icon>
                                                        <span class="operation-label">修改发货信息</span>
                                                </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item style='color:#409EFF'>
                                            <div
                                                v-show="
                                                        scop.row.orderStatus == 2
                                                    "
                                                @click="deliverGoods(scop.row, 2)"
                                            >
                                                <Icon size="16">
                                                    <Edit24Regular />
                                                </Icon>
                                                <span class="operation-label">修改收货地址</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item style='color:#409EFF'>
                                            <div
                                                v-show="
                                                    scop.row.orderStatus == 2 ||
                                                    scop.row.orderStatus == 3 ||
                                                    scop.row.orderStatus == 4 ||
                                                    scop.row.orderStatus == 5
                                                "
                                                @click="checkShopProductprint(scop.row)"
                                            >
                                                <Icon size="16">
                                                    <Edit24Regular />
                                                </Icon>
                                                <span class="operation-label" >打印订购单</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item style='color:#409EFF'>
                                            <div
                                                v-show="
                                                    scop.row.orderType == 6 &&
                                                    (scop.row.orderStatus == 3 ||
                                                    scop.row.orderStatus == 4 ||
                                                    scop.row.orderStatus == 5 ||
                                                    scop.row.orderStatus == 6)"
                                                @click="appointInfo(scop.row.reserveInfo)"
                                            >
                                                <Icon size="16">
                                                    <Edit24Regular />
                                                </Icon>
                                                <span class="operation-label" >预约信息</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item style='color:#409EFF'>
                                            <div
                                                @click="printOrder(scop.row.id)"
                                            >
                                                <Icon size="16">
                                                    <Edit24Regular />
                                                </Icon>
                                                <span class="operation-label" >补打小票</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item>
                                            <div @click="deleteShopProductOrder(scop.row.id)">
                                                <Icon size="16" style="color: red">
                                                    <Delete24Regular />
                                                </Icon>
                                                <span class="operation-label" style="color: red">删除</span>
                                            </div>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-box">
                    <el-pagination
                        @size-change="sizeChange"
                        @current-change="currentChange"
                        :current-page.sync="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalNum"
                        background
                        :pager-count="7"
                    >
                    </el-pagination>
                </div>
                <!-- 新增/查看/修改信息 -->
<!--                <el-dialog :title="shopProductOrderStates[shopProductOrderState]" :visible.sync="showDialog" width="60%" @close="closeDialog">-->
<!--                    <div>-->
<!--                        <el-form-->
<!--                            :model="shopProductOrder"-->
<!--                            ref="shopProductOrderForm"-->
<!--                            :rules="rules"-->
<!--                            label-width="80px"-->
<!--                            :inline="true"-->
<!--                            size="mini"-->
<!--                        >-->
<!--                            <el-form-item label="订单编号" prop="orderNumber">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderNumber"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="订单数量" prop="orderSize">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderSize"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="订单总价" prop="orderPrice">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderPrice"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="真实价格" prop="actualPrice">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.actualPrice"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="收件姓名" prop="orderContact">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderContact"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="用户姓名" prop="userRealname">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.user.userRealname"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="联系地址" prop="orderAddress">-->
<!--                                <el-input-->
<!--                                    style="width: 200px"-->
<!--                                    type="textarea"-->
<!--                                    :rows="1"-->
<!--                                    size="small"-->
<!--                                    v-model="shopProductOrder.orderAddress"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="手机号码" prop="orderTel">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderTel"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="订单备注" prop="orderRemarks">-->
<!--                                <el-input-->
<!--                                    style="width: 200px"-->
<!--                                    type="textarea"-->
<!--                                    :rows="1"-->
<!--                                    size="small"-->
<!--                                    v-model="shopProductOrder.orderRemarks"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="下单时间" prop="orderAddtime">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderAddtime"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="支付时间" prop="orderPaytime">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderPaytime"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="发货时间" prop="orderDelivertime">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderDelivertime"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="评价时间" prop="orderCommenttime">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderCommenttime"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="取消时间" prop="orderCanceltime">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderCanceltime"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="完成时间" prop="orderFinishtime">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderFinishtime"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="确认时间" prop="orderConfirmtime">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderConfirmtime"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->

<!--                            <el-form-item label="删除时间" prop="orderDeletetime">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderDeletetime"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="订单运费" prop="freightPrice">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.freightPrice"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            &lt;!&ndash; <el-form-item-->
<!--                  label="订单货运号"-->
<!--                  prop="orderFreightNo"-->
<!--                >-->
<!--                  <el-input-->
<!--                    size="small"-->
<!--                    v-model="shopProductOrder.orderFreightNo"-->
<!--                    :disabled="shopProductOrderState == 'check'"-->
<!--                  ></el-input>-->
<!--                </el-form-item> &ndash;&gt;-->
<!--                            <el-form-item label="物流公司" prop="freightName">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.freightName"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="运货单号" prop="freightNumber">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.freightNumber"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="物流备注" prop="freightRemarks">-->
<!--                                <el-input-->
<!--                                    style="width: 200px"-->
<!--                                    type="textarea"-->
<!--                                    :rows="1"-->
<!--                                    size="small"-->
<!--                                    v-model="shopProductOrder.freightRemarks"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="订单状态" prop="orderStatus">-->
<!--                                <el-select-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderStatus"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                >-->
<!--                                    &lt;!&ndash; <el-option v-for="status in orderStatusList" :key="status.key" :label="status.value" :value="status.key"> &ndash;&gt;-->
<!--                                    <el-option v-for="status in enumLists[shopProductOrder.orderType - 1]" :key="status.key" :label="status.value" :value="status.key">-->
<!--                                    </el-option>-->
<!--                                </el-select>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="付款方式" prop="payType">-->
<!--                                <el-select-->
<!--                                    style="width: 200px"-->
<!--                                    size="small"-->
<!--                                    v-model="shopProductOrder.payType"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                >-->
<!--                                    <el-option-->
<!--                                        v-for="pageType in payTypeList"-->
<!--                                        :key="pageType.key"-->
<!--                                        :label="pageType.value"-->
<!--                                        :value="pageType.key"-->
<!--                                    >-->
<!--                                    </el-option>-->
<!--                                </el-select>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="优惠卷" prop="couponId">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.couponId"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="消耗积分" prop="orderScore">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.orderScore"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="短信提醒" prop="isSmsRemind">-->
<!--                                <el-select-->
<!--                                    style="width: 200px"-->
<!--                                    size="small"-->
<!--                                    v-model="shopProductOrder.isSmsRemind"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                >-->
<!--                                    <el-option label="是" :value="1"> </el-option>-->
<!--                                    <el-option label="否" :value="0"> </el-option>-->
<!--                                </el-select>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="流水号码" prop="outTradeNo">-->
<!--                                <el-input-->
<!--                                    size="small"-->
<!--                                    style="width: 200px"-->
<!--                                    v-model="shopProductOrder.outTradeNo"-->
<!--                                    :disabled="shopProductOrderState == 'check'"-->
<!--                                ></el-input>-->
<!--                            </el-form-item>-->
<!--                        </el-form>-->
<!--                    </div>-->
<!--                    <div slot="footer" class="flex justify-end">-->
<!--                        <el-button @click="closeDialog">关闭</el-button>-->
<!--                        <el-button type="primary" @click="submitForm" v-if="shopProductOrderState != 'check'">确定</el-button>-->
<!--                    </div>-->
<!--                </el-dialog>-->
<!--                <el-dialog :title="shopProductOrderStates[shopProductOrderState]" :visible.sync="showDialog" width="80%" @close="closeDialog">-->
<!--                    <div style="display: flex">-->
<!--                        <div style="width: 50%;border-right: #8c939d 1px solid">-->
<!--                            <p style="font-weight: 500;font-size: 18px;text-align: center;margin-bottom: 16px">商品信息</p>-->
<!--                            <el-form-->
<!--                                :model="shopProductOrder"-->
<!--                                ref="shopProductOrderForm"-->
<!--                                :rules="rules"-->
<!--                                label-width="80px"-->
<!--                                :inline="true"-->
<!--                                size="mini"-->
<!--                            >-->
<!--                                <el-form-item label="订单编号" prop="orderNumber" v-if="shopProductOrder.orderNumber">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderNumber"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="订单数量" prop="orderSize" v-if="shopProductOrder.orderSize">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderSize"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="订单金额" prop="orderPrice" v-if="shopProductOrder.orderPrice">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderPrice"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="折扣金额" prop="discountPrice" v-if="shopProductOrder.discountPrice">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.discountPrice"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="实际价格" prop="actualPrice" v-if="shopProductOrder.actualPrice">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.actualPrice"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="成本价" prop="costPrice" v-if="shopProductOrder.costPrice">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.costPrice"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="供货价" prop="supplyPrice" v-if="shopProductOrder.supplyPrice">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.supplyPrice"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="下单时间" prop="orderAddtime" v-if="shopProductOrder.orderAddtime">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderAddtime"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="支付时间" prop="orderPaytime" v-if="shopProductOrder.orderPaytime">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderPaytime"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="付款方式" prop="payType" v-if="shopProductOrder.payType">-->
<!--                                    <el-select-->
<!--                                        style="width: 200px"-->
<!--                                        size="small"-->
<!--                                        v-model="shopProductOrder.payType"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    >-->
<!--                                        <el-option-->
<!--                                            v-for="pageType in payTypeList"-->
<!--                                            :key="pageType.key"-->
<!--                                            :label="pageType.value"-->
<!--                                            :value="pageType.key"-->
<!--                                        >-->
<!--                                        </el-option>-->
<!--                                    </el-select>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="优惠卷" prop="couponId" v-if="shopProductOrder.couponId">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.couponId"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="消耗积分" prop="orderScore" v-if="shopProductOrder.orderScore">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderScore"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="订单状态" prop="orderStatus" v-if="shopProductOrder.orderStatus">-->
<!--                                    <el-select-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderStatus"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    >-->
<!--                                        &lt;!&ndash; <el-option v-for="status in orderStatusList" :key="status.key" :label="status.value" :value="status.key"> &ndash;&gt;-->
<!--                                        <el-option v-for="status in enumLists[shopProductOrder.orderType - 1]" :key="status.key" :label="status.value" :value="status.key">-->
<!--                                        </el-option>-->
<!--                                    </el-select>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="流水号码" prop="outTradeNo" v-if="shopProductOrder.outTradeNo">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.outTradeNo"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="评价时间" prop="orderCommenttime" v-if="shopProductOrder.orderCommenttime">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderCommenttime"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="取消时间" prop="orderCanceltime" v-if="shopProductOrder.orderCanceltime">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderCanceltime"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="完成时间" prop="orderFinishtime" v-if="shopProductOrder.orderFinishtime">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderFinishtime"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="确认时间" prop="orderConfirmtime" v-if="shopProductOrder.orderConfirmtime">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderConfirmtime"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                            </el-form>-->
<!--                        </div>-->
<!--                        <div style="width: 50%;border-left: #8c939d 1px solid">-->
<!--                            <p style="font-weight: 500;font-size: 18px;text-align: center;margin-bottom: 16px">物流信息</p>-->
<!--                            <el-form-->
<!--                                :model="shopProductOrder"-->
<!--                                ref="shopProductOrderForm"-->
<!--                                :rules="rules"-->
<!--                                label-width="80px"-->
<!--                                :inline="true"-->
<!--                                size="mini"-->
<!--                            >-->
<!--                                <el-form-item label="用户姓名" prop="userRealname" v-if="shopProductOrder.user.userRealname">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.user.userRealname"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="用户昵称" prop="userNickname" v-if="shopProductOrder.user.userNickname">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.user.userNickname"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="收件姓名" prop="orderContact" v-if="shopProductOrder.orderContact">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderContact"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="联系地址" prop="orderAddress" v-if="shopProductOrder.orderAddress">-->
<!--                                    <el-input-->
<!--                                        style="width: 200px"-->
<!--                                        type="textarea"-->
<!--                                        :rows="1"-->
<!--                                        size="small"-->
<!--                                        v-model="shopProductOrder.orderAddress"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="手机号码" prop="orderTel" v-if="shopProductOrder.orderTel">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderTel"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="订单备注" prop="orderRemarks" v-if="shopProductOrder.orderRemarks">-->
<!--                                    <el-input-->
<!--                                        style="width: 200px"-->
<!--                                        type="textarea"-->
<!--                                        :rows="1"-->
<!--                                        size="small"-->
<!--                                        v-model="shopProductOrder.orderRemarks"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="发货时间" prop="orderDelivertime" v-if="shopProductOrder.orderDelivertime">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.orderDelivertime"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="订单运费" prop="freightPrice" v-if="shopProductOrder.freightPrice">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.freightPrice"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="物流公司" prop="freightName" v-if="shopProductOrder.freightName">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.freightName"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="运货单号" prop="freightNumber" v-if="shopProductOrder.freightNumber">-->
<!--                                    <el-input-->
<!--                                        size="small"-->
<!--                                        style="width: 200px"-->
<!--                                        v-model="shopProductOrder.freightNumber"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="物流备注" prop="freightRemarks" v-if="shopProductOrder.freightRemarks">-->
<!--                                    <el-input-->
<!--                                        style="width: 200px"-->
<!--                                        type="textarea"-->
<!--                                        :rows="1"-->
<!--                                        size="small"-->
<!--                                        v-model="shopProductOrder.freightRemarks"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
<!--                            </el-form>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div slot="footer" class="flex justify-end">-->
<!--                        <el-button @click="closeDialog">关闭</el-button>-->
<!--                        <el-button type="primary" @click="submitForm" v-if="shopProductOrderState != 'check'">确定</el-button>-->
<!--                    </div>-->
<!--                </el-dialog>-->
                <el-dialog :title="shopProductOrderStates[shopProductOrderState]" :visible.sync="showDialog" width="60%" @close="closeDialog">
                    <el-form
                        :model="shopProductOrder"
                        ref="shopProductOrderForm"
                        :rules="rules"
                        label-width="90px"
                        :inline="true"
                        size="mini"
                    >
                        <el-tabs type="border-card">
                            <el-tab-pane label="订单金额">
                                <el-divider content-position="left">
                                    <!--                                    <i class="el-icon-lock text-lg"></i>-->
                                    <span class="ml-1 text-base text-black font-semibold" style="color: #868282">订单信息</span>
                                </el-divider>
                                <el-form-item label="订单编号" prop="orderNumber" v-if="shopProductOrder.orderNumber">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderNumber"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="订单金额" prop="orderPrice" v-if="shopProductOrder.orderPrice != null">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderPrice"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="折扣金额" prop="discountPrice" v-if="shopProductOrder.discountPrice != null">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.discountPrice"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="实付金额" prop="actualPrice" v-if="shopProductOrder.actualPrice != null">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.actualPrice"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="成本价格" prop="costPrice" v-if="shopProductOrder.costPrice != null">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.costPrice"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="供货价格" prop="supplyPrice" v-if="shopProductOrder.supplyPrice != null">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.supplyPrice"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="结算价格" prop="settlePrice" v-if="shopProductOrder.settlePrice != null">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.settlePrice"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="字段1" prop="extendField1" v-if="false">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.extendField1"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="字段2" prop="extendField2" v-if="false">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.extendField2"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="字段3" prop="extendField3" v-if="false">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.extendField3"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
<!--                                <el-form-item label="优惠卷ID" prop="couponId" v-if="shopProductOrder.couponId != null">-->
<!--                                    <el-input-->
<!--                                        style="width: 200px"-->
<!--                                        size="small"-->
<!--                                        v-model="shopProductOrder.couponId"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    ></el-input>-->
<!--                                </el-form-item>-->
                                <el-form-item label="消耗积分" prop="orderScore" v-if="shopProductOrder.orderScore != null">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderScore"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="赠送积分" prop="giveScore" v-if="shopProductOrder.giveScore != null">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.giveScore"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>

                                <el-divider content-position="left" v-if="shopProductOrder.couponId">
                                    <!--                                    <i class="el-icon-lock text-lg"></i>-->
                                    <span class="ml-1 text-base text-black font-semibold" style="color: #868282">优惠券信息</span>
                                </el-divider>
                                <el-form-item label="优惠券名称" prop="couponId" v-if="shopProductOrder.couponId">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.coupon.couponName"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="优惠券类型" prop="couponId" v-if="shopProductOrder.couponId">
                                    <el-select
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.coupon.couponType"
                                        :disabled="shopProductOrderState == 'check'"
                                    >
                                        <el-option label="满减" :value="1"> </el-option>
                                        <el-option label="无门槛" :value="2"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="优惠券抵扣金额" prop="couponId" v-if="shopProductOrder.couponId">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.coupon.couponMoney"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>

                                <el-divider content-position="left" v-if="shopProductOrder.cardId">
                                    <!--                                    <i class="el-icon-lock text-lg"></i>-->
                                    <span class="ml-1 text-base text-black font-semibold" style="color: #868282">消费卡信息</span>
                                </el-divider>
                                <el-form-item label="消费卡卡号" prop="cardId" v-if="shopProductOrder.cardId">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.card.card.cardNumber"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <!--                                <el-form-item label="消费卡类型" prop="cardId" v-if="shopProductOrder.card.cardType != null">-->
                                <!--                                    &lt;!&ndash;                                    <el-input&ndash;&gt;-->
                                <!--                                    &lt;!&ndash;                                        style="width: 200px"&ndash;&gt;-->
                                <!--                                    &lt;!&ndash;                                        size="small"&ndash;&gt;-->
                                <!--                                    &lt;!&ndash;                                        v-model="shopProductOrder.card.cardType"&ndash;&gt;-->
                                <!--                                    &lt;!&ndash;                                        :disabled="shopProductOrderState == 'check'"&ndash;&gt;-->
                                <!--                                    &lt;!&ndash;                                    ></el-input>&ndash;&gt;-->
                                <!--                                    <el-select-->
                                <!--                                        style="width: 200px"-->
                                <!--                                        size="small"-->
                                <!--                                        v-model="shopProductOrder.card.cardType"-->
                                <!--                                        :disabled="shopProductOrderState == 'check'"-->
                                <!--                                    >-->
                                <!--                                        <el-option label="购物卡" :value="1"> </el-option>-->
                                <!--                                        <el-option label="礼品卡" :value="2"> </el-option>-->
                                <!--                                    </el-select>-->
                                <!--                                </el-form-item>-->
                                <!--                                <el-form-item label="消费卡余额" prop="cardId" v-if="shopProductOrder.card.leftMoney != null">-->
                                <!--                                    <el-input-->
                                <!--                                        style="width: 200px"-->
                                <!--                                        size="small"-->
                                <!--                                        v-model="shopProductOrder.card.leftMoney"-->
                                <!--                                        :disabled="shopProductOrderState == 'check'"-->
                                <!--                                    ></el-input>-->
                                <!--                                </el-form-item>-->
                                <el-form-item label="消费卡抵扣金额" prop="cardId" v-if="shopProductOrder.cardId">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.card.useMoney"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                            </el-tab-pane>



                            <el-tab-pane label="物流信息">
                                <el-divider content-position="left">
                                    <!--                                    <i class="el-icon-lock text-lg"></i>-->
                                    <span class="ml-1 text-base text-black font-semibold" style="color: #868282">收货信息</span>
                                </el-divider>
                                <el-form-item label="收件姓名" prop="orderContact" v-if="shopProductOrder.orderContact">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderContact"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="联系电话" prop="orderTel" v-if="shopProductOrder.orderTel">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderTel"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="收货地址" prop="orderAddress" v-if="shopProductOrder.orderAddress">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderAddress"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="下单留言" prop="orderRemarks" v-if="shopProductOrder.orderRemarks">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderRemarks"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-divider content-position="left">
<!--                                    <i class="el-icon-lock text-lg"></i>-->
                                    <span class="ml-1 text-base text-black font-semibold" style="color: #868282">发货信息</span>
                                </el-divider>
                                <el-form-item label="是否包邮" prop="isFreightFree">
                                    <el-select
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.isFreightFree"
                                        :disabled="shopProductOrderState == 'check'"
                                    >
                                        <el-option label="是" :value="1"> </el-option>
                                        <el-option label="否" :value="0"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="快递费用" prop="freightPrice" v-if="shopProductOrder.freightPrice">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.freightPrice"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="物流公司" prop="freightName" v-if="shopProductOrder.freightName != null && shopProductOrder.freightName != ''">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.freightName"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="运货单号" prop="freightNumber" v-if="shopProductOrder.freightNumber != null && shopProductOrder.freightNumber != ''">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.freightNumber"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="发货备注" prop="freightRemarks" v-if="shopProductOrder.freightRemarks != null && shopProductOrder.freightRemarks != ''">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.freightRemarks"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                            </el-tab-pane>
                            <el-tab-pane label="其他信息">
                                <el-divider content-position="left">
                                    <!--                                    <i class="el-icon-lock text-lg"></i>-->
                                    <span class="ml-1 text-base text-black font-semibold" style="color: #868282">所属信息</span>
                                </el-divider>
                                <el-form-item label="所属用户" prop="userId" v-if="shopProductOrder.user">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.user.userName"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="所属店铺" prop="shopId" v-if="shopProductOrder.shopId">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.shopId"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="所属门店" prop="storeId" v-if="shopProductOrder.storeId">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.storeId"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-divider content-position="left">
                                    <!--                                    <i class="el-icon-lock text-lg"></i>-->
                                    <span class="ml-1 text-base text-black font-semibold" style="color: #868282">类型信息</span>
                                </el-divider>
                                <el-form-item label="商品类型" prop="productType" v-if="shopProductOrder.productType">
                                    <el-select
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.productType"
                                        :disabled="shopProductOrderState == 'check'"
                                    >
                                        <el-option v-for="item in productType" :label="item.value" :value="item.key"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="订单状态" prop="orderStatus" v-if="shopProductOrder.orderStatus">
                                    <el-select
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderStatus"
                                        :disabled="shopProductOrderState == 'check'"
                                    >
                                        <el-option v-for="item in orderStatusList" :label="item.value" :value="item.key"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="组织类型" prop="orgType" v-if="shopProductOrder.orgType">
<!--                                    <el-select-->
<!--                                        style="width: 200px"-->
<!--                                        size="small"-->
<!--                                        v-model="shopProductOrder.orgType"-->
<!--                                        :disabled="shopProductOrderState == 'check'"-->
<!--                                    >-->
<!--                                        <el-option v-for="item in orgList" :label="item.value" :value="item.key"> </el-option>-->
<!--                                    </el-select>-->
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orgType"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="订单类型" prop="orderType" v-if="shopProductOrder.orderType">
                                    <el-select
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderType"
                                        :disabled="shopProductOrderState == 'check'"
                                    >
                                        <el-option v-for="item in orderTypeEnum" :label="item.value" :value="item.key"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="配送方式" prop="deliverMethod" v-if="shopProductOrder.deliverMethod">
                                    <el-select
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.deliverMethod"
                                        :disabled="shopProductOrderState == 'check'"
                                    >
                                        <el-option v-for="item in this[`deliverMethodList${shopProductOrder.orderType}`]" :label="item.value" :value="item.key"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-divider content-position="left">
                                    <!--                                    <i class="el-icon-lock text-lg"></i>-->
                                    <span class="ml-1 text-base text-black font-semibold" style="color: #868282">支付信息</span>
                                </el-divider>
                                <el-form-item label="支付类型" prop="payType" v-if="shopProductOrder.payType">
                                    <el-select
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.payType"
                                        :disabled="shopProductOrderState == 'check'"
                                    >
                                        <el-option v-for="item in payTypeList" :label="item.value" :value="item.key"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="外部单号" prop="payNo" v-if="shopProductOrder.payNo">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.payNo"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="统一支付ID" prop="payId" v-if="shopProductOrder.payId">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.payId"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="货币类型" prop="currencyType">
                                    <el-select
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.currencyType"
                                        :disabled="shopProductOrderState == 'check'"
                                    >
                                        <el-option v-for="item in currencyList" :label="item.value" :value="item.key"> </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-divider content-position="left">
                                    <!--                                    <i class="el-icon-lock text-lg"></i>-->
                                    <span class="ml-1 text-base text-black font-semibold" style="color: #868282">开票信息</span>
                                </el-divider>
                                <el-form-item label="发票类型" prop="userId" v-if="shopProductOrder.invoiceObj.invoiceType">
                                    <el-select
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.invoiceObj.invoiceType"
                                        :disabled="shopProductOrderState == 'check'"
                                    >
                                        <el-option label="无" :value="0"> </el-option>
                                        <el-option label="普票" :value="1"> </el-option>
                                        <el-option label="增票" :value="2"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="公司名称" prop="userId" v-if="shopProductOrder.invoiceObj.invoiceType">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.invoiceObj.companyName"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="公司税号" prop="userId" v-if="shopProductOrder.invoiceObj.taxNumber">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.invoiceObj.taxNumber"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="公司注册地址" prop="userId" v-if="shopProductOrder.invoiceObj.registerAddress">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.invoiceObj.registerAddress"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="公司电话" prop="userId" v-if="shopProductOrder.invoiceObj.taxNumber">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.invoiceObj.taxNumber"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="发票内容" prop="userId" v-if="shopProductOrder.invoiceObj.invoiceContent">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.invoiceObj.invoiceContent"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="其他备注" prop="userId" v-if="shopProductOrder.invoiceObj.remarks">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.invoiceObj.remarks"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="企业开户银行" prop="userId" v-if="shopProductOrder.invoiceObj.bankName">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.invoiceObj.bankName"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="开户行帐号" prop="userId" v-if="shopProductOrder.invoiceObj.accountNumber">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.invoiceObj.accountNumber"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="联系人" prop="userId" v-if="shopProductOrder.invoiceObj.contacts">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.invoiceObj.contacts"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="联系电话" prop="userId" v-if="shopProductOrder.invoiceObj.contactNumber">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.invoiceObj.contactNumber"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="邮寄地址" prop="userId" v-if="shopProductOrder.invoiceObj.receiveAddress">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.invoiceObj.receiveAddress"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                            </el-tab-pane>
                            <el-tab-pane label="操作时间">
                                <el-form-item label="下单时间" prop="orderAddtime" v-if="shopProductOrder.orderAddtime">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderAddtime"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="取消时间" prop="orderCanceltime" v-if="shopProductOrder.orderCanceltime">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderCanceltime"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="支付时间" prop="orderPaytime" v-if="shopProductOrder.orderPaytime">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderPaytime"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="发货时间" prop="orderDelivertime" v-if="shopProductOrder.orderDelivertime">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderDelivertime"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="确认时间" prop="orderConfirmtime" v-if="shopProductOrder.orderConfirmtime">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderConfirmtime"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="评价时间" prop="orderCommenttime" v-if="shopProductOrder.orderCommenttime">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderCommenttime"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="完成时间" prop="orderFinishtime" v-if="shopProductOrder.orderFinishtime">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderFinishtime"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="结算时间" prop="orderSettletime" v-if="shopProductOrder.orderSettletime">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderSettletime"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="删除时间" prop="orderDeletetime" v-if="shopProductOrder.orderDeletetime">
                                    <el-input
                                        style="width: 200px"
                                        size="small"
                                        v-model="shopProductOrder.orderDeletetime"
                                        :disabled="shopProductOrderState == 'check'"
                                    ></el-input>
                                </el-form-item>
                            </el-tab-pane>
                            <el-tab-pane label="商品信息">
                                <el-table
                                    :header-cell-style="{ textAlign: 'center' }"
                                    :cell-style="{ textAlign: 'center' }"
                                    :data="shopProductOrder.shopOrderSkuList"
                                    row-key="id"
                                    size="small"
                                    style="margin-top: 0;width: 100%"
                                    height="100%"
                                >
                                    <!-- <el-table-column align="center" type="selection" :selectable="selectable" width="60"> </el-table-column> -->
                                    <el-table-column :show-overflow-tooltip="true" align="center" label="商品图片">
                                        <template slot-scope="scope">
                                            <el-image
                                                @click='updateSrcList(scope.row.shopProduct.productPic)'
                                                style="width: 30px; height: 30px"
                                                :src="scope.row.shopProduct.productPic"
                                                :preview-src-list="srcList"
                                            > </el-image>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        :show-overflow-tooltip="true"
                                        align="left"
                                        prop="shopProduct.productName"
                                        label="商品名称"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        :show-overflow-tooltip="true"
                                        align="left"
                                        prop="skuKvNames"
                                        label="商品规格"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        :show-overflow-tooltip="true"
                                        align="left"
                                        prop="skuPrice"
                                        label="商品价格"
                                    >
                                        <template scope='scope'>
                                            ￥{{scope.row.skuPrice}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        :show-overflow-tooltip="true"
                                        align="left"
                                        prop="orderSize"
                                        label="商品数量"
                                    >
                                        <template scope='scope'>
                                            {{scope.row.orderSize}}件
                                        </template>
                                    </el-table-column>
                                    <el-table-column :show-overflow-tooltip="true" align="center" label="商品状态" width="200">
                                        <template slot-scope="scope">
                                            <div>
                                                <div
                                                    v-if="scope.row.returnWay == 1 && scope.row.returnStatus == 1"
                                                    @click="retreat(scope.row)"
                                                    style="margin-bottom: 10px; width: 85px; height: 20px;padding: 0;"
                                                    type="primary"
                                                    size="small"
                                                >申请退款中</div>
                                                <div
                                                    v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 1"
                                                    @click="retreat(scope.row)"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >申请退货/退款中</div>
                                                <div
                                                    v-if="scope.row.returnWay == 1 && scope.row.returnStatus == 2"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >拒绝退款</div>
                                                <div
                                                    v-if="scope.row.returnWay == 1 && scope.row.returnStatus == 5"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >同意退款</div>
                                                <div
                                                    v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 2"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >拒绝退货/退款</div>
                                                <div
                                                    v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 3"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >待补充运单号</div>
                                                <div
                                                    v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 4"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    @click="retreat(scope.row)"
                                                    type="primary"
                                                    size="small"
                                                >已补充运单号</div>
                                                <div
                                                    v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 5"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >同意退货/退款</div>
                                                <div
                                                    @click="afterSalesRecord(scope.row.id)"
                                                    v-if="scope.row.returnWay"
                                                    style="margin-bottom: 4px; width: 80px; height: 20px"
                                                    type="primary"
                                                    size="small"
                                                >售后记录</div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column align="center" label="物流信息" width="150">
                                        <template slot-scope="scop">
                                            <div class="operation" v-show="scop.row.shopOrderDelivery !== null">
                                                <div @click="checkShopProductOrders(scop.row.id)">
                                                    <Icon size="16">
                                                        <Eye24Regular />
                                                    </Icon>
                                                    <span class="operation-label">查看物流</span>
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column> -->
                                </el-table>
                            </el-tab-pane>
                        </el-tabs>
                    </el-form>
                    <div slot="footer" class="flex justify-end">
                        <el-button @click="closeDialog">关闭</el-button>
                        <el-button type="primary" @click="submitForm" v-if="shopProductOrderState != 'check'">确定</el-button>
                    </div>
                </el-dialog>
                <!-- 订单查看 -->
                <el-dialog
                    :title="shopProductOrderStates[shopProductOrderState]"
                    :visible.sync="showDialogs"
                    width="400px"
                    @close="closeDialog"
                >
                    <div>
                        <el-form :model="logistics" ref="shopProductOrderForm" :rules="rules" label-width="80px" :inline="true" size="mini">
                            <!-- <el-form-item label="订单运费" prop="freightPrice">
                                <el-input
                                    size="small"
                                    style="width: 200px"
                                    v-model="shopProductOrder.freightPrice"
                                    :disabled="shopProductOrderState == 'check'"
                                ></el-input>
                            </el-form-item> -->

                            <el-form-item label="物流公司" prop="freightName">
                                <el-input
                                    size="small"
                                    style="width: 200px"
                                    v-model="logistics.freightName"
                                    :disabled="shopProductOrderState == 'check'"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="运货单号" prop="freightNumber">
                                <el-input
                                    size="small"
                                    style="width: 200px"
                                    v-model="logistics.freightNumber"
                                    :disabled="shopProductOrderState == 'check'"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="物流备注" prop="freightRemarks">
                                <el-input
                                    style="width: 200px"
                                    type="textarea"
                                    :rows="1"
                                    size="small"
                                    v-model="logistics.freightRemarks"
                                    :disabled="shopProductOrderState == 'check'"
                                ></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div slot="footer" class="flex justify-end">
                        <el-button @click="closeDialog">关闭</el-button>
                    </div>
                </el-dialog>

                <!-- 发货 -->
                <el-dialog title="发货" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
                    <el-divider content-position="left">
                        <span class="ml-1 text-base text-black font-semibold" style="color: #868282">订单信息</span>
                    </el-divider>
                    <div class="deliver-box">
                        <div class="deliver-item">
                            <span>订单编号：{{shopProductOrder.orderNumber}}</span>
                        </div>
                        <div class="deliver-item">
                            <span>订单金额：{{shopProductOrder.orderPrice}}</span>
                        </div>
                        <div class="deliver-item">
                            <span>折扣金额：{{shopProductOrder.discountPrice}}</span>
                        </div>
                        <div class="deliver-item">
                            <span>实付金额：{{shopProductOrder.actualPrice}}</span>
                        </div>
                        <div class="deliver-item">
                            <span>成本价格：{{shopProductOrder.costPrice}}</span>
                        </div>
                        <div class="deliver-item">
                            <span>供货价格：{{shopProductOrder.supplyPrice}}</span>
                        </div>
                        <div class="deliver-item">
                            <span>结算价格：{{shopProductOrder.settlePrice}}</span>
                        </div>
                        <div class="deliver-item">
                            <span>消耗积分：{{shopProductOrder.orderScore}}</span>
                        </div>
                        <div class="deliver-item">
                            <span>赠送积分：{{shopProductOrder.giveScore}}</span>
                        </div>
                    </div>
                    <el-form
                        ref="shopProductOrder"
                        :inline="true"
                        :model="shopProductOrder"
                        :rules="shopProductOrderRules"
                        size="small"
                        label-width="80px"
                    >
                        <el-divider content-position="left">
                            <span class="ml-1 text-base text-black font-semibold" style="color: #868282">发货信息</span>
                        </el-divider>
                        <el-form-item label="订单运费" prop="freightPrice">
                            <el-input disabled style="width: 200px" v-model="shopProductOrder.freightPrice"></el-input>
                        </el-form-item>
                        <el-form-item label="物流公司" prop="freightName">
                            <el-input :disabled="mode === 2" style="width: 200px" v-model="shopProductOrder.freightName"></el-input>
                        </el-form-item>
                        <el-form-item label="运货单号" prop="freightNumber">
                            <el-input :disabled="mode === 2" style="width: 200px" v-model="shopProductOrder.freightNumber"></el-input>
                        </el-form-item>
                        <el-form-item label="发货备注" prop="freightRemarks">
                            <el-input :disabled="mode === 2" style="width: 780px" type="textarea" :rows="3" v-model="shopProductOrder.freightRemarks"></el-input>
                        </el-form-item>
                    </el-form>

<!--                    收获信息-->
                    <el-form
                        ref="shopProductOrder"
                        :inline="true"
                        :model="shopProductOrder"
                        :rules="shopProductOrderRules"
                        size="small"
                        label-width="80px"
                    >
                        <el-divider content-position="left">
                            <span class="ml-1 text-base text-black font-semibold" style="color: #868282">收货信息</span>
                        </el-divider>
                        <el-form-item label="收货姓名" prop="orderContact">
                            <el-input :disabled="mode !== 2" style="width: 200px" v-model="shopProductOrder.orderContact"></el-input>
                        </el-form-item>
                        <el-form-item label="收货电话" prop="orderTel">
                            <el-input :disabled="mode !== 2" style="width: 200px" v-model="shopProductOrder.orderTel"></el-input>
                        </el-form-item>
                        <el-form-item label="收货地址" prop="orderAddress">
                            <el-input :disabled="mode !== 2" style="width: 780px" type="textarea" :rows="3" v-model="shopProductOrder.orderAddress"></el-input>
                        </el-form-item>
                    </el-form>
<!--                    <el-divider content-position="left">-->
<!--                        <span class="ml-1 text-base text-black font-semibold" style="color: #868282">收货信息</span>-->
<!--                    </el-divider>-->
<!--                    <div class="deliver-box">-->
<!--                        <div class="deliver-item">-->
<!--                            <span>收货姓名：{{shopProductOrder.orderContact}}</span>-->
<!--                        </div>-->
<!--                        <div class="deliver-item">-->
<!--                            <span>收货电话：{{shopProductOrder.orderTel}}</span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="deliver-box">-->
<!--                        <div class="deliver-item" style="height: 50px;width: 100%;padding-top: 10px; align-items: flex-start">-->
<!--                            <span>收货地址：{{shopProductOrder.orderAddress}}</span>-->
<!--                        </div>-->
<!--                    </div>-->
                    <el-divider content-position="left">
                        <span class="ml-1 text-base text-black font-semibold" style="color: #868282">商品信息</span>
                    </el-divider>
                    <el-table
                        :header-cell-style="{ textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center' }"
                        :data="shopProductOrder.shopOrderSkuList"
                        row-key="id"
                        size="small"
                        style="margin-top: 0;width: 100%"
                        height="100%"
                    >
                        <!-- <el-table-column align="center" type="selection" :selectable="selectable" width="60"> </el-table-column> -->
                        <el-table-column :show-overflow-tooltip="true" align="center" label="商品图片">
                            <template slot-scope="scope">
                                <el-image
                                    @click='updateSrcList(scope.row.shopProduct.productPic)'
                                    style="width: 30px; height: 30px"
                                    :src="scope.row.shopProduct.productPic"
                                    :preview-src-list="srcList"
                                > </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="left"
                            prop="shopProduct.productName"
                            label="商品名称"
                        >
                        </el-table-column>
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="left"
                            prop="skuKvNames"
                            label="商品规格"
                        >
                        </el-table-column>
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="left"
                            prop="skuPrice"
                            label="商品价格"
                        >
                            <template scope='scope'>
                                ￥{{scope.row.skuPrice}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="left"
                            prop="orderSize"
                            label="商品数量"
                        >
                            <template scope='scope'>
                                {{scope.row.orderSize}}件
                            </template>
                        </el-table-column>
                        <el-table-column :show-overflow-tooltip="true" align="center" label="商品状态" width="200">
                            <template slot-scope="scope">
                                <div>
                                    <div
                                        v-if="scope.row.returnWay == 1 && scope.row.returnStatus == 1"
                                        @click="retreat(scope.row)"
                                        style="margin-bottom: 10px; width: 85px; height: 20px;padding: 0;"
                                        type="primary"
                                        size="small"
                                    >申请退款中</div>
                                    <div
                                        v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 1"
                                        @click="retreat(scope.row)"
                                        style="margin-bottom: 4px; width: 80px; height: 20px"
                                        type="primary"
                                        size="small"
                                    >申请退货/退款中</div>
                                    <div
                                        v-if="scope.row.returnWay == 1 && scope.row.returnStatus == 2"
                                        style="margin-bottom: 4px; width: 80px; height: 20px"
                                        type="primary"
                                        size="small"
                                    >拒绝退款</div>
                                    <div
                                        v-if="scope.row.returnWay == 1 && scope.row.returnStatus == 5"
                                        style="margin-bottom: 4px; width: 80px; height: 20px"
                                        type="primary"
                                        size="small"
                                    >同意退款</div>
                                    <div
                                        v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 2"
                                        style="margin-bottom: 4px; width: 80px; height: 20px"
                                        type="primary"
                                        size="small"
                                    >拒绝退货/退款</div>
                                    <div
                                        v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 3"
                                        style="margin-bottom: 4px; width: 80px; height: 20px"
                                        type="primary"
                                        size="small"
                                    >待补充运单号</div>
                                    <div
                                        v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 4"
                                        style="margin-bottom: 4px; width: 80px; height: 20px"
                                        @click="retreat(scope.row)"
                                        type="primary"
                                        size="small"
                                    >已补充运单号</div>
                                    <div
                                        v-if="scope.row.returnWay == 2 && scope.row.returnStatus == 5"
                                        style="margin-bottom: 4px; width: 80px; height: 20px"
                                        type="primary"
                                        size="small"
                                    >同意退货/退款</div>
                                    <div
                                        @click="afterSalesRecord(scope.row.id)"
                                        v-if="scope.row.returnWay"
                                        style="margin-bottom: 4px; width: 80px; height: 20px"
                                        type="primary"
                                        size="small"
                                    >售后记录</div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">关闭</el-button>
                    <el-button v-if="shopProductOrder.orderStatus == 2 && mode !== 2" type="primary" @click="successButton('shopProductOrder')">发货</el-button>
                    <el-button v-if="shopProductOrder.orderStatus == 2 && mode === 2" type="primary" @click="setAddress()">修改收货地址</el-button>
                    <el-button v-if="shopProductOrder.orderStatus == 3" type="primary" @click="setAddress()">修改发货信息</el-button>
                </span>
                </el-dialog>

                <!-- 审核退货退款 -->
                <el-dialog title="售后服务" :visible.sync="retreatDialogVisible" width="30%" :before-close="handleCloseRetreat">
                    <el-form ref="retreatForm" :rules="retreatRules" size="small" :model="retreatForm" label-width="100px">
                        <el-form-item label="是否同意：" prop="resource">
                            <el-radio-group v-model="retreatForm.resource">
                                <el-radio label="true">是</el-radio>
                                <el-radio label="false">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="拒绝原因：" v-if="retreatForm.resource == 'false'" prop="desc">
                            <el-input style="width: 300px" type="textarea" v-model="retreatForm.desc"></el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                    <el-button @click="handleCloseRetreat">取 消</el-button>
                    <el-button type="primary" @click="retreatSuccess('retreatForm')">确 定</el-button>
                </span>
                </el-dialog>

                <!-- 售后记录 -->
                <el-dialog title="售后记录" :visible.sync="afterRecordDialogVisible" width="40%" :before-close="afterRecordhandleClose">
                    <div class="afterRecord">
                        <div v-for="(item, index) of recordList" :key="index" class="">
                            <!-- 用户提交 -->
                            <div class="ReturnProcess" v-if="item.recordType == 1">
                                <el-row>
                                    <el-col :span="17"
                                    ><div class="">{{ item.recordText }}</div></el-col
                                    >
                                    <el-col :span="7"
                                    ><div class="">时间:{{ item.createTime }}</div></el-col
                                    >
                                </el-row>
                                <el-row v-if="item.returnWay">
                                    <el-col :span="24"
                                    ><div class="">退款方式：{{ item.returnWay == 1 ? '仅退款' : '退货/退款' }}</div></el-col
                                    >
                                </el-row>
                                <el-row v-if="item.freightName">
                                    <el-col :span="24"
                                    ><div class="">物流公司：{{ item.freightName }}</div></el-col
                                    >
                                </el-row>
                                <el-row v-if="item.freightNumber">
                                    <el-col :span="24"
                                    ><div class="">物流单号：{{ item.freightNumber }}</div></el-col
                                    >
                                </el-row>
                                <el-row v-if="item.returnReason">
                                    <el-col :span="24"
                                    ><div class="">退款原因：{{ item.returnReason }}</div></el-col
                                    >
                                </el-row>
                                <el-row v-if="item.returnMoney">
                                    <el-col :span="24"
                                    ><div class="">退款金额：￥{{ item.returnMoney }}</div></el-col
                                    >
                                </el-row>
                                <el-row v-if="item.returnRemark">
                                    <el-col :span="24"
                                    ><div class="">退款说明：{{ item.returnRemark }}</div></el-col
                                    >
                                </el-row>
                                <el-row v-if="item.returnPic">
                                    <el-col :span="24"
                                    ><el-image
                                        v-for="(itemn, indexn) of item.returnPic"
                                        :key="indexn"
                                        style="width: 100px; height: 100px; margin: 0 10px 10px 0"
                                        :src="itemn"
                                        :preview-src-list="item.returnPic"
                                    >
                                    </el-image
                                    ></el-col>
                                </el-row>
                                <el-row v-if="item.freightPic">
                                    <el-col :span="24"
                                    ><el-image
                                        v-for="(itemn, indexn) of item.freightPic"
                                        :key="indexn"
                                        style="width: 100px; height: 100px; margin: 0 10px 10px 0"
                                        :src="itemn"
                                        :preview-src-list="item.freightPic"
                                    >
                                    </el-image
                                    ></el-col>
                                </el-row>
                            </div>
                            <div class="ReturnProcess" v-if="item.recordType == 2">
                                <el-row>
                                    <el-col :span="17"
                                    ><div class="">{{ item.recordText }}</div></el-col
                                    >
                                    <el-col :span="7"
                                    ><div class="">时间:{{ item.createTime }}</div></el-col
                                    >
                                </el-row>
                                <el-row v-if="item.refuseReason">
                                    <el-col :span="24"
                                    ><div class="">拒绝原因：{{ item.refuseReason }}</div></el-col
                                    >
                                </el-row>
                            </div>
                        </div>
                    </div>

                    <span slot="footer" class="dialog-footer">
                    <el-button @click="afterRecordDialogVisible = false">关闭</el-button>
                </span>
                </el-dialog>
                <!-- 打印 -->
                <el-dialog title="订购单打印" :visible.sync="showPrint" width="800px" @close="closeDialog">
                    <div id="printMe" ref="printContent">
                        <div class="top_mess">
                            <div>
                                <div class="top_title">
                                    <div class="top_span">
                                        <div class="top_span1">
                                            <span class="info_center">{{ printData.printTitle }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="customer">
                                    <div class="customer-left">
                                        <div>客户姓名：{{ orderContact }}</div>
                                        <div style="margin-top: 15px">客户地址：{{ orderAddress }}</div>
                                    </div>
                                    <div class="customer-right">
                                        <div>编&nbsp;&nbsp;号：{{ orderNumber }}</div>
                                        <div style="margin-top: 15px">客户电话：{{ orderTel }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form_list">
                                <el-table
                                    style="margin-top: 5px"
                                    :data="printList"
                                    row-key="id"
                                    size="small"
                                    show-summary
                                    :summary-method="getSummaries"
                                    border
                                >
                                    <el-table-column :show-overflow-tooltip="true" align="center" label="商品货号" width="80"></el-table-column>
                                    <el-table-column
                                        :show-overflow-tooltip="true"
                                        align="center"
                                        prop="shopProduct.productName"
                                        label="商品名称"
                                    ></el-table-column>
                                    <el-table-column :show-overflow-tooltip="true" align="center" width="80" label="规格型号">
                                        <template slot-scope="scope">
                                            {{ scope.row.skuKvNames }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        :show-overflow-tooltip="true"
                                        align="center"
                                        prop="orderSize"
                                        width="60"
                                        label="数量"
                                    ></el-table-column>
                                    <el-table-column
                                        :show-overflow-tooltip="true"
                                        align="center"
                                        prop="skuPrice"
                                        width="60"
                                        label="单价"
                                    ></el-table-column>
                                    <el-table-column :show-overflow-tooltip="true" align="center" width="60" label="金额">
                                        <template slot-scope="scope">
                                            {{ scope.row.orderSize * scope.row.skuPrice }}
                                        </template>
                                    </el-table-column>
<!--                                    <el-table-column :show-overflow-tooltip="true" align="center" label="备注"></el-table-column>-->
                                </el-table>
                            </div>
                            <div class="customer">
                                <div class="customer-left">
                                    <div>发货人：{{ printData.deliverContact }}</div>
                                    <div>发货地址：{{  printData.deliverAddress }}</div>
                                </div>
                                <div class="customer-right">
                                    <div>日期：{{ orderDelivertime }}</div>
                                    <div>电话：{{ printData.deliverMobile }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div slot="footer" class="flex justify-end">
                        <el-button @click="closeDialog">关闭</el-button>
                        <el-button type="primary" @click="closeCallback" v-print="printObj">打印</el-button>
                    </div>
                </el-dialog>
                <!-- 预约 -->
                <el-dialog :title="appointmentStatus == false ? '预约' : '预约信息'" :visible.sync="dialogVisibles" width="30%" :before-close="handleCloses">
                    <el-form
                        ref="appointment"
                        :inline="true"
                        :model="appointment"
                        :rules="appointmentRules"
                        size="small"
                        label-width="80px"
                    >
                        <el-form-item label="姓名" prop="name">
                            <el-input style="width: 200px" v-model="appointment.name" :disabled="appointmentStatus"></el-input>
                        </el-form-item>
                        <el-form-item label="电话" prop="tel">
                            <el-input style="width: 200px" v-model="appointment.tel" :disabled="appointmentStatus"></el-input>
                        </el-form-item>
                        <el-form-item label="预约时间" prop="time">
                            <!-- <el-input style="width: 200px" v-model="appointment.sex"></el-input> -->
                            <el-date-picker
                                v-model="appointment.time"
                                :disabled="appointmentStatus"
                                style="width: 200px"
                                value-format="yyyy-MM-dd"
                                type="date"
                                :picker-options="pickerOptions"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="用户类型" prop="type">
                            <!-- <el-input style="width: 200px" v-model="appointment.type"></el-input> -->
                            <el-select style="width: 200px" v-model="appointment.type" placeholder="请选择" :disabled="appointmentStatus">
                                <el-option label="新客户" value="新客户"></el-option>
                            <!-- <el-option label="老客户" value="老客户"></el-option> -->
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                    <el-button @click="handleCloses">关闭</el-button>
                    <el-button type="primary" v-if="!appointmentStatus" @click="successButtons('appointment')">预约</el-button>
                </span>
                </el-dialog>
                <upload-excel :uploadExcelVisible="uploadExcelVisible" :importUrl="importUrl" @finish="finish" @cancel="cancel"></upload-excel>
            </div>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import axios from 'axios';
import uploadExcel from '../../components/common/uploadExcel.vue';
import GridSelectShop from '@/components/gridselect/gidselect.vue';
import { SHOP, SHOP_SEARCH } from '@/utils/constant.js'
import InformationEdit from '@/components/shop/InformationEdit.vue';

export default {
    components: {
        InformationEdit,
        GridSelectShop,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        uploadExcel
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopProductOrderList();
                this.getShopProductOrderList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopProductOrderList();
                this.getShopProductOrderList();
                this.$emit('resetCheckState');
            }
        },
        tabs(val){
            switch (val) {
                case 'zero': this.queryForm.orderStatus='';
                    this.getShopProductOrderList();
                    break;
                case 'first': this.queryForm.orderStatus=0;
                    this.getShopProductOrderList();
                    break;
                case 'second': this.queryForm.orderStatus=1;
                    this.getShopProductOrderList();
                    break;
                case 'third': this.queryForm.orderStatus=2;
                    this.getShopProductOrderList();
                    break;
                case 'fourth': this.queryForm.orderStatus=3;
                    this.getShopProductOrderList();
                    break;
                case 'fifth': this.queryForm.orderStatus=4;
                    this.getShopProductOrderList();
                    break;
                case 'sixth': this.queryForm.orderStatus=5;
                    this.getShopProductOrderList();
                    break;
                case 'seventh': this.queryForm.orderStatus=6;
                    this.getShopProductOrderList();
                    break;
                // case 'eight': this.queryForm.orderStatus=7;
                //     this.getShopProductOrderList();
                //     break;
                // case 'nine': this.queryForm.orderStatus=8;
                //     this.getShopProductOrderList();
                //     break;
                // case 'ten': this.queryForm.orderStatus=9;
                //     this.getShopProductOrderList();
                //     break;
                // case 'eleven': this.queryForm.orderStatus=10;
                //     this.getShopProductOrderList();
                //     break;
                // case 'twelve': this.queryForm.orderStatus=11;
                //     this.getShopProductOrderList();
                //     break;
            }
        }
        //监听table这个对象
        // printList: {
        //     immediate: true,
        //     handler() {
        //         this.$nextTick(() => {
        //             const tds = document.querySelectorAll('#table .el-table__footer-wrapper tr>td');
        //             tds[0].colSpan = 5;
        //             tds[0].style.textAlign = 'center';
        //             tds[1].style.display = 'none';
        //         });
        //     }
        // }
    },
    data() {
        return {
            SHOP_code: SHOP,
            SHOP_search: SHOP_SEARCH,
            showShop: 0,
            mode: 1,
            tabs:'zero',
            uploadExcelVisible: false,
            importUrl: '/shop/order/import',
            printList: [],
            orderTel: '',
            orderNumber: '',
            orderDelivertime: '',
            orderContact: '',
            orderAddress: '',
            orderInfoList: [],
            printObj: {
                id: 'printMe', //id
                popTitle: '订购单打印' //自定义设置标题
            },
            logistics: {
                freightName: '', //物流公司
                freightNumber: '', //运货单号
                freightRemarks: '' //物流备注
            },
            seatc: [],
            // cheak: false,
            // chack: false,
            // chacked: '',
            showPrint: false,
            dialogVisible: false,
            retreatDialogVisible: false,
            afterRecordDialogVisible: false,
            retreatForm: {
                resource: '',
                desc: ''
            },
            queryForm: {
                shopId: '', //店铺id
                userName: '', //用户名称
                orderNumber: '', //订单编号
                orderSize: '', //数量
                orderPrice: '', //订单总价
                orderStartPrice: '',
                orderEndPrice: '',
                actualPrice: '', //真实价格
                orderLink: '', //订单连接
                orderContact: '',
                orderAddress: '', //联系地址
                orderTel: '', //手机号
                orderRemarks: '', //订单备注、留言
                productId: '', //产品id
                userId: '', //用户编号
                orderAddtime: '', //添加时间
                startAddtime: '',
                endAddtime: '',
                orderPaytime: '', //付款时间
                startPayTime: '',
                endPayTime: '',
                orderCanceltime: '', //退回时间
                startCancelTime: '',
                endCancelTime: '',
                orderFinishtime: '', //完成时间
                startFinishTime: '',
                orderDelivertime: '',
                orderCommenttime: '',
                orderConfirmtime: '',
                couponId: '',
                orderScore: '',
                endFinishTime: '',
                orderDeletetime: '', //删除时间
                freightPrice: '', //运费
                orderFreightNo: '', //订单货运号
                freightName: '', //物流公司
                freightNumber: '', //运货单号
                freightRemarks: '', //物流备注
                orderStatus:'', //订单状态
                orderType: '',
                targetId: '',
                isSmsRemind: '', //是否短信提醒：1：是；0：否
                isComment: '', //是否评论：0：没有评论；1：有评论
                payType: '', //1：支付宝 2：微信 3：余额 4：货到付款
                outTradeNo: '', //支付台平流水号
                createUserId: '', //创建人
                createTime: '', //创建时间
                updateUserId: '', //更新人
                updateTime: '', //更新时间
                deleteFlag: '', //是否删除
                startDeliverTime: '',
                endDeliverTime: '',
                minOrderPrice: '',
                maxOrderPrice: '',
                payNo: ''
            },
            addtimeRange: [], //下单时间范围
            paytimeRange: [], //付款时间范围
            canceltimeRange: [], //取消时间范围
            finishtimeRange: [], //订单完成时间范围
            delivertimeRange: [], //发货时间
            dictValueList: [], //是否短信提醒
            payTypeList: [], //支付状态
            orderStatusList: [], //订单状态
            loading: false,
            showDialog: false,
            showDialogs: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopProductOrderState: 'add',
            shopProductOrderStates: {
                check: '查看订单'
            },
            // countOrderStatus:{},
            orderStatusEnum:[],
            multipleSelection: [],
            shopProductOrderList: [],
            shopProductOrder: {
                orderNumber: '', //订单数量
                orderSize: 0, //数量
                orderPrice: '', //订单总价
                actualPrice: '', //真实价格
                orderLink: '', //订单连接
                orderAddress: '', //联系地址
                orderTel: '', //手机号
                orderRemarks: '', //订单备注、留言
                productId: '', //产品id 未使用
                userId: '', //用户编号
                user: {}, //用户
                product: {}, //产品
                orderAddtime: '', //添加时间
                orderPaytime: '', //付款时间
                orderCanceltime: '', //退回时间
                orderFinishtime: '', //完成时间
                orderDeletetime: '', //删除时间
                freightPrice: '', //运费
                orderFreightNo: '', //订单货运号
                freightName: '', //物流公司
                freightNumber: '', //运货单号
                freightRemarks: '', //物流备注
                orderStatus: '', //订单状态
                isSmsRemind: '', //是否短信提醒：1：是；0：否
                isComment: '', //是否评论：0：没有评论；1：有评论
                payType: '', //1：支付宝 2：微信 3：余额 4：货到付款
                outTradeNo: '', //支付台平流水号
                createUserId: '', //创建人
                createTime: '', //创建时间
                updateUserId: '', //更新人
                updateTime: '', //更新时间
                deleteFlag: '', //是否删除
                seq: '', //序列号
                invoiceObj: {},
                cardId: '',
                couponId: '',
                coupon: {
                    couponName: '',
                    couponType: '',
                    couponMoney: ''
                },
                card: {
                    useMoney: '',
                    card: {
                        cardNumber: "",
                    }
                }
            },
            shopProductOrderRules: {
                freightName: [{ required: true, message: '物流公司不能为空', trigger: 'blur' }],
                freightNumber: [{ required: true, message: '物流单号不能为空', trigger: 'blur' }],
                orderAddress: [{ required: true, message: '收货地址不能为空', trigger: 'blur' }],//联系地址
                orderTel: [{ required: true, message: '联系方式不能为空', trigger: 'blur' }],//手机号
                orderContact: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],//手机号
            },
            shopProductArrderrRules: {
                orderAddress: [{ required: true, message: '收货地址不能为空', trigger: 'blur' }],//联系地址
                orderTel: [{ required: true, message: '联系方式不能为空', trigger: 'blur' }],//手机号
                orderContact: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],//手机号
            },
            retreatRules: {
                resource: [{ required: true, message: '请选择是否同意', trigger: 'change' }],
                desc: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }]
            },
            appointmentRules: {
                name: [{ required: true, message: '预约人姓名不能为空', trigger: 'blur' }],
                tel: [{ required: true, message: '预约人手机号不能为空', trigger: 'blur' }],
                time: [{ required: true, message: '预约时间不能为空', trigger: 'blur' }],
                type: [{ required: true, message: '用户类型不能为空', trigger: 'blur' }]
            },
            btnLoading: false,
            rules: {},
            auditStatus: [],
            orderTypeList: [
                { key: 1, value: '购买订单' },
                { key: 2, value: '兑换订单' },
                { key: 3, value: '秒杀订单' },
                { key: 4, value: '拼团订单' },
                { key: 5, value: '砍价订单' }
            ],
            activityShow: false,
            orderReturnStatus: 0,
            skuId: '',
            recordList: [],
            mytime: '',
            srcList:[''],//大图预览
            printData:{
                deliverAddress:'',
                deliverContact:'',
                deliverMobile:'',
                printTitle:'',
            },
            enumList1: [],
            enumList2: [],
            enumList3: [],
            productType: [],
            orderTypeEnum : [],
            appointment:{
                name: '',// 姓名
                tel: '',// 手机号
                time: '',// 预约时间
                type: '新客户' // 用户类型
            },
            appointmentStatus: false,
            dialogVisibles: false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 86400000; // 只允许选择今天及以后的日期
                }
            },
            deliverMethodList1: [],
            deliverMethodList2: [],
            deliverMethodList3: [],
            // deliverMethodList4: [],
            // deliverMethodList5: [],
            // deliverMethodList6: [],
            orgList: [],
            currencyList: [],
            invoiceObj: {},
            systemCurrencyList: [],
            orderSourceList: [],
        };
    },
    created() {
        this.getEnums();
        this.getShopProductOrderList();
        this.getPayType();
        this.getOrderStatus();
        this.getAuditStatus();
        // this.getCountOrderStatus();
        this.getOrderStatusEnum();
        this.getOrderPrintInfo();
        this.getShowShop();
        let myDate = new Date(new Date().getTime() + 8 * 60 * 60 * 1000);
        let time = myDate.toJSON().split('T').join(' ').substr(0, 19);
        this.mytime = time;
        this.getProductType();
		// this.getSystemCurrencyType();
    },
    updated() {
        this.$refs.multipleTable.doLayout();
    },
    methods: {
        // 预约信息
        appointInfo(item){
            this.appointmentStatus = true
            this.dialogVisibles = true
            let arraynow = []
            let array = item.split("\n")
            for (let arrayElement of array) {
                arraynow.push(arrayElement.split("：")[1])
            }
            // console.log(arraynow)
            this.appointment = {
                name: arraynow[0],// 姓名
                tel: arraynow[1],// 手机号
                time: arraynow[2],// 预约时间
                type: arraynow[3] // 用户类型
            }
            // console.log(array)
        },
        // 获取枚举
        getProductType(){
            get("/mpp/utils/getEnum",{enumType:"product_type"}).then((res)=>{
                if(res.success && res.code == 200){
                    this.productType = res.enumList
                    console.log('this.productType',this.productType);
                }
            })
            get(`/mpp/utils/getEnum`, { enumType: `order_type` }).then((res) => {
                if (res.success) {
                    this.orderTypeEnum = res.enumList;
                }
            });
            get(`/mpp/utils/getEnum`, { enumType: `currency_type` }).then((res) => {
                if (res.success) {
                    this.currencyList = res.enumList;
                }
            });
            get(`/shop/utils/getEnum`, { enumType: `shop_order_source_status` }).then((res) => {
                if (res.success) {
                    this.orderSourceList = res.enumList;
                }
            });
            // get(`/mpp/utils/getEnum`, { enumType: `org_type` }).then((res) => {
            //     if (res.success) {
            //         this.orgList = res.enumList;
            //     }
            // });
            for (let i = 1; i <= 3; i++) {
                get(`/mpp/utils/getEnum`,{enumType: `order_type${i}_deliver_method`}).then((res)=>{
                    if(res.success){
                        this[`deliverMethodList${i}`] = res.enumList;
                    }
                })
            }
        },
        returnItems(ordertype,mothods){
            for (let Key in this[`deliverMethodList${ordertype}`]) {
                if(this[`deliverMethodList${ordertype}`][Key].key == mothods){
                    return this[`deliverMethodList${ordertype}`][Key].value
                }
            }
            return this[`deliverMethodList${ordertype}`];
        },
        // 返回枚举内容
        getEnumLists(item, sign){
            if(sign == 'productType'){
                for (let i = 0; i < this.productType.length; i++) {
                    if (this.productType[i].key == item) {
                        return this.productType[i].value;
                    }
                }
            }else if(sign == 'orderSource'){
                for (let i = 0; i < this.orderSourceList.length; i++){
                    if (this.orderSourceList[i].key == item) {
                        return this.orderSourceList[i].value;
                    }
                }
            }else if(sign == 'currencyType'){
                for (let i = 0; i < this.currencyList.length; i++) {
                    if (this.currencyList[i].key == item) {
                        return this.currencyList[i].value;
                    }
                }
            }else{
                for (let i = 0; i < this.orderTypeEnum.length; i++) {
                    if (this.orderTypeEnum[i].key == item) {
                        return this.orderTypeEnum[i].value;
                    }
                }
            }
        },
        // 下一个状态
        deliverGoods1(item,label){
            let ChangeStatus = {
                id: item.id,
                currentStatus: item.orderStatus,
                newStatus: item.orderStatus + 1
            }
            this.$confirm(`确定${label}吗？`, '提示', {
                type: 'warning'
            })
                .then(() => {
                    post(`/shop/order/changeOrderStatus`, ChangeStatus).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopProductOrderList();
                            this.getShopProductOrderList();
                        }
                    });
                })
                .catch(() => {});
        },
        deliverGoods3(item){
            this.dialogVisibles = true;
            this.appointmentStatus = false
            // console.log(this.appointment);
            // console.log(item);
            this.appointment = { ...this.appointment, ...item };
        },
        setAddress(){
            this.$refs['shopProductOrder'].validate((valid) => {
                delete this.shopProductOrder.coupon
                delete this.shopProductOrder.user
                delete this.shopProductOrder.card
                delete this.shopProductOrder.shopOrderSkuList
                delete this.shopProductOrder.shop
                delete this.shopProductOrder.shopCouponReceive
                delete this.shopProductOrder.shopCard
                delete this.shopProductOrder.shopCardUse
                delete this.shopProductOrder.store
                if (valid) {
                    //console.log('submit');
                    post(`/shop/order/edit`, { ...this.shopProductOrder }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.handleClose();
                            this.resetShopProductOrderList();
                            this.getShopProductOrderList();
                        }
                    });
                }
            });
        },
        deliverGoods2(item,json = '',sign){
            let ChangeStatus = {
                id: item.id,
                currentStatus: item.orderStatus,
                newStatus: item.orderStatus + 1,
            }
            if(json != ''){
                ChangeStatus = {...ChangeStatus, formJson:json}
            }
            post(`/shop/order/changeOrderStatus`, ChangeStatus).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    if(sign == 'fahuo'){
                        this.handleClose()
                    }else if(sign == 'yuyue'){
                        this.handleCloses()
                    }
                    this.resetShopProductOrderList();
                    this.getShopProductOrderList();
                }
            });
        },
        // 按钮作用
        getBtnMethod(item){
            let orderType = item.orderType - 1;
            let orderStatus = item.orderStatus;
            if(orderStatus == 0 || orderStatus == 5 || orderStatus == 6){
                // 已取消，已完成，已关闭
                // this.deliverGoods1(item,'');
            }else if(orderStatus == 1){
                // 待付款
                // this.deliverGoods1(item,'确认付款');
            }else if(orderType == 0 && orderStatus == 2){
                // 待发货
                this.deliverGoods(item);
            }else if(orderType == 0 && orderStatus == 3){
                // 待收货
                this.deliverGoods1(item,'确认收货');
            }else if(orderStatus == 4){
                // 待评价
                // this.deliverGoods1(item,'已评价');
            }else if(orderType == 1 && orderStatus == 3){
                // 待核销
                this.deliverGoods1(item,'核销');
            }else if(orderType == 1 && orderStatus == 2){
                // 待预约
                this.deliverGoods3(item);
            }else if(orderType == 2 && orderStatus == 2){
                // 待发送
                this.deliverGoods1(item,'已发送');
            }else if(orderType == 1 && orderStatus == 3){
                // 待使用
                this.deliverGoods1(item,'已使用');
            }
        },
        // 按钮文字
        getBtnName(orderTypes,orderStatus){
            let orderType = orderTypes - 1;
            if(orderStatus == 0 || orderStatus == 5 || orderStatus == 6){
                // 已取消，已完成，已关闭
                return '';
            }else if(orderStatus == 1){
                // 待付款
                // return '确认付款';
                return '';
            }else if(orderType == 0 && orderStatus == 2){
                // 待发货
                return '发货';
            }else if(orderType == 0 && orderStatus == 3){
                // 待收货
                if(this.showConfirmOrder != 1){
                    return '';
                }
                return '确认收货';
            }else if(orderStatus == 4){
                // 待评价
                // return '已评价';
                return '';
            }else if(orderType == 1 && orderStatus == 3){
                // 待核销
                return '核销';
            }else if(orderType == 1 && orderStatus == 2){
                // 待预约
                return '预约';
            }else if(orderType == 2 && orderStatus == 2){
                // 待发送
                return '已发送';
            }else if(orderType == 1 && orderStatus == 3){
                // 待使用
                return '已使用';
            }
        },

        // 获取所有订单枚举
        getEnums(){
            get('/shop/utils/getEnum?enumType=shop_order1_status').then((res) => {
                this.enumList1 = res.enumList;
            });
            get('/shop/utils/getEnum?enumType=shop_order2_status').then((res) => {
                this.enumList2 = res.enumList;
            });
            get('/shop/utils/getEnum?enumType=shop_order3_status').then((res) => {
                this.enumList3 = res.enumList;
            });
        },

        returnGetEnums(orderType,orderStatus){
            if(!orderType || !orderStatus){
                return
            }
            let array = this['enumList' + orderType];
            for (let keys = 0; keys < array.length; keys++) {
                if(array[keys].key == orderStatus){
                    return array[keys].value;
                }
            }
        },

        closeCallback() {
            this.showPrint = false;
        },

        updateSrcList(src){
            this.srcList[0] = src
        },

        getSummaries(param) {
            let d = [];
            const { columns, data } = param;
            // console.log(data);
            data.map((item) => {
                let c = item.orderSize * item.skuPrice;
                // console.log(c);
                d.push(c);
            });
            console.log(d);

            // var sum = d.reduce(function (a, b) {
            //     console.log(a);
            //     console.log(b);
            //     console.log(parseInt(a) + parseInt(b));
            //     return parseInt(a) + parseInt(b);
            // }, 0);
            // console.log(sum);

            var sum = d.reduce(function (prev, cur) {
                return prev + cur;
            }, 0);
            console.log(sum);

            // let arr = [1, 2, 3, 5]

            // varsum = arr.reduce(function (prev, cur) {
            //     return prev + cur;
            // }, 0);
            // console.log(varsum)

            // var sum = d.map((item) => {
            //     let acc = 0;
            //     acc += item;
            //     return acc;
            // });
            // console.log(sum);
            // var sum = d.map((item) => {
            //     acc += item;
            // });
            // return acc;
            // console.log(acc);

            // let arr = [1, 2, 3, 4, 5, 1];
            // function one(arr) {
            //     let sum = 0;
            //     arr.map(function (item) {
            //         sum += item;
            //     });
            //     return sum;
            // }
            // console.log(one(arr))

            const sums = [];
            columns.forEach((column, index) => {
                if (index == 0) {
                    sums[index] = '合计';
                    return;
                }
                if (index == 5) {
                    sums[index] = sum;
                    return;
                }
                const values = data.map((item) => Number(item[column.property]));
                if (!values.every((value) => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if (index == 5) {
                        sums[index];
                    }
                    if (index == 4) {
                        sums[index] = null;
                    }
                    if (index == 7) {
                        sums[index];
                    }
                } else {
                    sums[index] = '';
                }
            });
            console.log('sumssumssumssums',sums);
            return sums;
        },

        selectable(row, index) {
            if (row.shopOrderDelivery == null || row.shopOrderDelivery.orderStatus == 2) {
                return true;
            } else {
                return false;
            }
        },
        getUserAuditStatus(auditStatus) {
            for (const index in this.auditStatus) {
                if (this.auditStatus[index].key == auditStatus) {
                    return this.auditStatus[index].value;
                }
            }
        },
        getAuditStatus() {
            get('/mpp/utils/getEnum', { enumType: 'audit_status' }).then((res) => {
                this.auditStatus = res.enumList;
            });
        },
        //根据订单状态值找标签
        getOrderLabel(orderStatus) {
            for (const index in this.orderStatusList) {
                if (this.orderStatusList[index].key == orderStatus) {
                    return this.orderStatusList[index].value;
                }
            }
        },
        //根据支付方式值找标签
        getPayTypeLabel(payType) {
            for (const index in this.payTypeList) {
                if (this.payTypeList[index].key === payType) {
                    //console.log(this.payTypeList[index].value);
                    return this.payTypeList[index].value;
                }
            }
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopProductOrderList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopProductOrderList = [];
        },
        resetDialog() {
            this.shopProductOrderState = 'add';
            this.showDialog = false;
            this.queryForm = {
                shopId: '', //店铺id
                checkName: '',
                orderSize: '', //数量
                orderPrice: '', //订单总价
                actualPrice: '', //真实价格
                orderLink: '', //订单连接
                orderAddress: '', //联系地址
                orderTel: '', //手机号
                orderRemarks: '', //订单备注、留言
                productId: '', //产品id 未使用
                userId: '', //用户编号
                orderAddtime: '', //添加时间
                orderPaytime: '', //付款时间
                orderCanceltime: '', //退回时间
                orderFinishtime: '', //完成时间
                orderDeletetime: '', //删除时间
                freightPrice: '', //运费
                orderFreightNo: '', //订单货运号
                freightName: '', //物流公司
                freightNumber: '', //运货单号
                freightRemarks: '', //物流备注
                orderStatus: '', //订单状态
                isSmsRemind: '', //是否短信提醒：1：是；0：否
                isComment: '', //是否评论：0：没有评论；1：有评论
                payType: '', //1：支付宝 2：微信 3：余额 4：货到付款
                outTradeNo: '', //支付台平流水号
                createUserId: '', //创建人
                createTime: '', //创建时间
                updateUserId: '', //更新人
                updateTime: '', //更新时间
                deleteFlag: '', //是否删除
                startAddtime: '', //下单开始时间
                endAddtime: '', //下单结束时间
                startPayTime: '', //支付开始时间
                endPayTime: '', //支付结束时间
                startCancelTime: '', //取消订单开始时间
                endCancelTime: '', //取消订单结束时间
                startFinishTime: '', //完成开始时间
                endFinishTime: '', //完成结束时间
                startDeliverTime: '', //发货开始时间
                endDeliverTime: '', //发货结束时间
                minOrderPrice: '',
                maxOrderPrice: '',
                payNo: ''
            };
            this.addtimeRange = [];
            this.paytimeRange = [];
            this.canceltimeRange = [];
            this.finishtimeRange = [];
            this.delivertimeRange = [];
            this.getShopProductOrderList();
        },
        closeDialog() {
            // this.resetDialog();
            this.showPrint = false;
            this.showDialog = false;
            this.showDialogs = false;
        },
        submitForm() {
            if (this.shopProductOrderState == 'add') {
                this.$refs.shopProductOrderForm.validate((valid) => {
                    if (valid) {
                        //console.log('submit');
                        post(`/shop/order/add`, { ...this.shopProductOrder }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopProductOrderList();
                                this.resetDialog();
                                this.getShopProductOrderList();
                            }
                        });
                    }
                });
            } else if (this.shopProductOrderState == 'edit') {
                this.$refs.shopProductOrderForm.validate((valid) => {
                    if (valid) {
                        //console.log('submit');
                        post(`/shop/order/edit`, { ...this.shopProductOrder }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopProductOrderList();
                                this.resetDialog();
                                this.getShopProductOrderList();
                            }
                        });
                    }
                });
            }
        },
        addShopProductOrder() {
            (this.shopProductOrder = {}), (this.showDialog = true);
            this.shopProductOrderState = 'add';
        },
        checkShopProductprint(e) {


            //打印
            this.orderTel = '';
            this.orderNumber = '';
            this.orderDelivertime = '';
            this.orderContact = '';
            this.orderAddress = '';
            this.showPrint = true;
            this.orderInfoList = e;
            this.orderTel = this.orderInfoList.orderTel;
            this.orderNumber = this.orderInfoList.orderNumber;
            this.orderDelivertime = this.mytime.split(' ')[0];
            this.orderContact = this.orderInfoList.orderContact;
            this.orderAddress = this.orderInfoList.orderAddress;
            console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeee:',this.orderInfoList)
            this.printList = this.orderInfoList.shopOrderSkuList;
            // this.printList.push(null);
            console.log('111111111111111111111111',this.printList);
        },
        checkShopProductOrder(shopProductOrderId) {
            console.log(shopProductOrderId);
            this.currentShopProductOrderId = shopProductOrderId;
            this.getShopProductOrderById();
            this.showDialog = true;
            this.shopProductOrderState = 'check';
        },
        getShopProductInvoiceId(id){
            get('/shop/orderinvoice/getByOrderId?orderId=' + id).then((res)=>{
                if (res.success) {
                    this.shopProductOrder.invoiceObj = res.shopOrderInvoice;
                    console.log(this.shopProductOrder.invoiceObj);
                }
            })
        },
        getShopProductCardId(id){
            get('/shop/carduse/getByOrderId?orderId=' + id).then((res)=>{
                if (res.success) {
                    this.shopProductOrder.card.useMoney = res.shopCardUse.useMoney || '';
                    if(String(res.shopCardUse.useMoney) == '0'){
                        this.shopProductOrder.card.useMoney = res.shopCardUse.useMoney
                    }
                    this.shopProductOrder.card.card.cardNumber = res.shopCardUse.card.cardNumber || '';
                    console.log(this.shopProductOrder);
                }
            })
        },
        getShopProductCouponId(id){
            get('/shop/couponreceive/get?id=' + id).then((res)=>{
                if (res.success) {
                    this.shopProductOrder.coupon.couponName = res.shopUserCoupon.couponName || '';
                    this.shopProductOrder.coupon.couponMoney = res.shopUserCoupon.couponMoney || '';
                    this.shopProductOrder.coupon.couponType = res.shopUserCoupon.couponType || '';
                    console.log(this.shopProductOrder);
                }
            })
        },
        checkShopProductOrders(shopProductOrderId) {
            console.log(shopProductOrderId);
            this.currentShopProductOrderId = shopProductOrderId;
            this.getShopProductOrderByIds();
            this.showDialogs = true;
            this.shopProductOrderState = 'check';
        },
        editShopProductOrder(shopProductOrderId) {
            //console.log('shopProductOrder', shopProductOrderId);
            if (shopProductOrderId) {
                this.currentShopProductOrderId = shopProductOrderId;
                this.getShopProductOrderById();
            } else {
                this.shopProductOrder = { ...this.shopProductOrder, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopProductOrderState = 'edit';
        },
        deleteShopProductOrder(shopProductOrderId) {
            let ids = '';
            if (shopProductOrderId) {
                ids = shopProductOrderId;
            } else {
                ids = this.multipleSelection.map((shopProductOrder) => shopProductOrder.id).join(',');
            }
            //console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/order/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopProductOrderList();
                            this.getShopProductOrderList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopProductOrderList() {
            this.resetShopProductOrderList();
            this.getShopProductOrderList();
        },
        getShopProductOrderList(query = {}) {
            this.loading = true;
            this.queryForm.startAddtime = '';
            this.queryForm.endAddtime = '';
            this.queryForm.startPayTime = '';
            this.queryForm.endPayTime = '';
            this.queryForm.startCancelTime = '';
            this.queryForm.endCancelTime = '';
            this.queryForm.startFinishTime = '';
            this.queryForm.endFinishTime = '';
            this.queryForm.startDeliverTime = "";
            this.queryForm.endDeliverTime = "";
            if (this.addtimeRange != null) {
                this.queryForm.startAddtime = this.addtimeRange[0];
                this.queryForm.endAddtime = this.addtimeRange[1];
            }
            if (this.paytimeRange != null) {
                this.queryForm.startPayTime = this.paytimeRange[0];
                this.queryForm.endPayTime = this.paytimeRange[1];
            }
            if (this.canceltimeRange != null) {
                this.queryForm.startCancelTime = this.canceltimeRange[0];
                this.queryForm.endCancelTime = this.canceltimeRange[1];
            }
            if (this.finishtimeRange != null) {
                this.queryForm.startFinishTime = this.finishtimeRange[0];
                this.queryForm.endFinishTime = this.finishtimeRange[1];
            }
            if (this.delivertimeRange != null) {
                this.queryForm.startDeliverTime = this.delivertimeRange[0];
                this.queryForm.endDeliverTime = this.delivertimeRange[0];
            }
            console.log(this.queryForm);
            get(`/shop/order/findRefundList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopProductOrderList = res.page.list;
                    for (let item1 of this.shopProductOrderList) {
                        item1.orderSize = 0;
                        for (let item2 of item1.shopOrderSkuList) {
                            item1.orderSize += item2.orderSize;
                        }
                    }
                    this.totalNum = res.page.total;
                }
            });
        },
        getShopProductOrderById() {
            this.shopProductOrder.invoiceObj = {}
            this.shopProductOrder.card = {
                useMoney: '',
                card: {
                    cardNumber: "",
                }
            }
            this.shopProductOrder.coupon = {
                couponName: '',
                couponType: '',
                couponMoney: ''
            }
            get(`/shop/order/get`, { id: this.currentShopProductOrderId }).then((res) => {
                console.log(res);
                if (res.success) {
                    this.shopProductOrder = { ...this.shopProductOrder, ...res.shopOrder };
                    this.shopProductOrder.orderSize = 0;
                    for (let item of this.shopProductOrder.shopOrderSkuList) {
                        this.shopProductOrder.orderSize += item.orderSize;
                    }
                    // this.getShopProductInvoiceId(this.currentShopProductOrderId);
                    // if(res.shopOrder.id){
                    //     // this.getShopProductCardId(res.shopOrder.id)
                    // }
                    if(res.shopOrder.couponId){
                        this.getShopProductCouponId(res.shopOrder.couponId)
                    }
                }
            });
        },
        getShopProductOrderByIds() {
            this.logistics = {
                freightName: '', //物流公司
                freightNumber: '', //运货单号
                freightRemarks: '' //物流备注
            };
            console.log(this.currentShopProductOrderId);
            get(`/shop/order/selectProductDelivery`, { id: this.currentShopProductOrderId }).then((res) => {
                console.log(res);
                // if (res.success) {
                //     this.shopProductOrder = { ...this.shopProductOrder, ...res.shopProductOrder };
                //     this.shopProductOrder.orderSize = 0;
                //     for (let item of this.shopProductOrder.shopOrderSkuList) {
                //         this.shopProductOrder.orderSize += item.orderSize;
                //     }
                // }
                this.logistics = res.orderSkuList.shopOrderDelivery;
                console.log(res.orderSkuList.shopOrderDelivery);
                console.log(this.logistics);
                // console.log(arrs);
                // this.shopProductOrder = res;
                // console.log(this.shopProductOrder);
            });
        },
        /**
         * 导出订单信息
         */
        exportShopProductOrderList() {
            // this.btnLoading = true;
            // exprotExcel(`/shop/order/export`, { ...this.queryForm });

            axios({
                // 默认请求方式为get
                method: 'get',
                url: '/shop/order/export',
                // 传递参数
                params: {
                    ...this.queryForm
                },
                responseType: 'blob'
            })
                .then((res) => {
                    if (res.data.type) {
                        // 文件下载
                        const blob = new Blob([res.data], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        });
                        let link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.setAttribute('download', '导出数据.xlsx');
                        link.click();
                        link = null;
                        Message({ message: '导出成功', type: 'success' });
                    } else {
                        // 返回json
                        this.$message.warning(res.data.msg);
                    }
                })
                .catch((err) => {
                    this.btnLoading = false;
                    this.$message.error('导出失败');
                });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/order/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.uploadExcelVisible = true;
        },
        // 确定导入
        finish(res) {
            if (res.success && res.code == 200) {
                this.$message.success('导入成功');
            } else {
                this.$message.error('导入失败');
            }
            this.uploadExcelVisible = false;
            this.getShopProductOrderList();
        },
        // 取消导入
        cancel(val) {
            this.uploadExcelVisible = val;
        },

        //获取支付方式
        getPayType() {
            get('/mpp/utils/getEnum', { enumType: 'order_pay_type' }).then((data) => {
                if (data.success) {
                    this.payTypeList = data.enumList;
                }
            });
        },
        //获取订单状态
        getOrderStatus() {
            get('/mpp/utils/getEnum', { enumType: 'order_status_shop' }).then((data) => {
                if (data.success) {
                    this.orderStatusList = data.enumList;
                    // console.log(this.orderStatusList);
                }
            });
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            //console.log({ formData });
            importDate(`/shop/order/importData`, formData);
            this.refreshShopProductOrderList();
        },
        //最外层选择
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
            let arr = [];
            this.seatc = [];
            if (value != '') {
                console.log(111);
                if (value[0].shopOrderSkuList) {
                    value[0].shopOrderSkuList.map((item) => {
                        if (item.shopOrderDelivery == null || item.shopOrderDelivery.orderStatus == 2) {
                            this.seatc.push(item.id);
                        }
                    });
                    console.log(this.seatc);
                } else {
                    value.map((item) => {
                        this.seatc.push(item.id);
                    });
                }
            } else {
                console.log(222);
                return;
            }
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopProductOrderList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopProductOrderList();
        },
        // 发货
        deliverGoods(item, index = 1) {
            this.mode = index
            this.dialogVisible = true;
            console.log(this.shopProductOrder);
            console.log(item);
            this.shopProductOrder = { ...this.shopProductOrder, ...item };
        },
        handleClose() {
            this.dialogVisible = false;
        },
        handleCloses() {
            this.dialogVisibles = false;
            this.appointment = {
                name: '',// 姓名
                tel: '',// 手机号
                time: '',// 预约时间
                type: '' // 用户类型
            }
        },
        // 发货确认
        successButton(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let items = {
                        id: this.shopProductOrder.id,
                        orderStatus: this.shopProductOrder.orderStatus
                    }
                    let obj = {
                        // id: this.shopProductOrder.id,
                        freightName: this.shopProductOrder.freightName,
                        freightNumber: this.shopProductOrder.freightNumber,
                        freightRemarks: this.shopProductOrder.freightRemarks
                    }
                    this.deliverGoods2(items,JSON.stringify(obj),'fahuo')
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        // 预约确认
        successButtons(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let items = {
                        id: this.appointment.id,
                        orderStatus: this.appointment.orderStatus
                    }
                    let obj = {
                        // id: this.appointment.id,
                        name: this.appointment.name,
                        tel: this.appointment.tel,
                        time: this.appointment.time,
                        type: this.appointment.type,
                    }
                    this.deliverGoods2(items,JSON.stringify(obj),'yuyue')
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        // successButton(formName) {
        //     console.log(formName);
        //     this.$refs[formName].validate((valid) => {
        //         console.log(this.shopProductOrder.id);
        //         console.log(this.seatc.join(''));
        //         console.log(this.shopProductOrder.freightName);
        //         console.log(this.shopProductOrder.freightNumber);
        //         console.log(this.shopProductOrder.freightRemarks);
        //         if (this.seatc == '') {
        //             console.log(1111);
        //             if (valid) {
        //                 post('/shop/order/deliverOrder', {
        //                     id: this.shopProductOrder.id,
        //                     freightName: this.shopProductOrder.freightName,
        //                     freightNumber: this.shopProductOrder.freightNumber,
        //                     freightRemarks: this.shopProductOrder.freightRemarks
        //                 }).then((res) => {
        //                     if (res.success && res.code == 200) {
        //                         this.$message({
        //                             message: res.msg,
        //                             type: 'success',
        //                             duration: 2000
        //                         });
        //                     }
        //                     this.dialogVisible = false;
        //                     this.getShopProductOrderList();
        //                 });
        //             } else {
        //                 console.log('error submit!!');
        //                 return false;
        //             }
        //         } else {
        //             console.log(2222);
        //             if (valid) {
        //                 post('/shop/order/deliveryOrder', {
        //                     id: this.shopProductOrder.id,
        //                     shopOrderSkuListsId: this.seatc.join(''),
        //                     freightName: this.shopProductOrder.freightName,
        //                     freightNumber: this.shopProductOrder.freightNumber,
        //                     freightRemarks: this.shopProductOrder.freightRemarks
        //                 }).then((res) => {
        //                     if (res.success && res.code == 200) {
        //                         this.$message({
        //                             message: res.msg,
        //                             type: 'success',
        //                             duration: 2000
        //                         });
        //                     }
        //                     this.dialogVisible = false;
        //                     this.getShopProductOrderList();
        //                 });
        //             } else {
        //                 console.log('error submit!!');
        //                 return false;
        //             }
        //         }
        //     });
        // },

        // 退货退款 type=1仅退款
        retreat(item) {
            this.skuId = item.id;
            this.retreatForm = {
                resource: '',
                desc: ''
            };
            this.retreatDialogVisible = true;
        },
        handleCloseRetreat() {
            this.retreatDialogVisible = false;
        },
        retreatSuccess(formName) {
            // 后台审核退回订单
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.retreatDialogVisible = false;
                    post('/shop/orderreturn/auditReturnOrder', {
                        skuId: this.skuId,
                        agree: this.retreatForm.resource == 'true' ? true : false,
                        reason: this.retreatForm.resource == 'false' ? this.retreatForm.desc : ''
                    }).then((res) => {
                        if (res.success && res.code == 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                        this.getShopProductOrderList();
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getValueShopId(value){
            this.queryForm.shopId = value
        },
        afterSalesRecord(id) {
            this.afterRecordDialogVisible = true;
            get('/shop/orderreturn/findAll', { skuId: id }).then((res) => {
                if (res.success && res.code == 200) {
                    this.recordList = res.list;
                    for (let item of this.recordList) {
                        if (item.returnPic) {
                            let list = item.returnPic.split(',');
                            item.returnPic = [];
                            item.returnPic = list.map((item) => {
                                return item;
                            });
                        }
                        if (item.freightPic) {
                            let list = item.freightPic.split(',');
                            item.freightPic = [];
                            item.freightPic = list.map((item) => {
                                return item;
                            });
                        }
                    }
                }
            });
        },
        afterRecordhandleClose() {
            this.afterRecordDialogVisible = false;
        },

        // // 获取所以状态订单的总数
        // getCountOrderStatus(){
        //     get('/shop/order/countShopOrderStatus').then((res)=>{
        //         if(res.success){
        //             this.countOrderStatus = res.map
        //         }
        //     })
        // },

        // 获取订单状态枚举
        getOrderStatusEnum(){
            get('/mpp/utils/getEnum',{
                enumType:"order_status_shop"
            }).then((res)=>{
                if(res.success){
                    this.orderStatusEnum = res.enumList
                }
            })
        },

        // 获取打印订单基础信息
        getOrderPrintInfo(){
            get('/mpp/utils/getOrderPrintInfo').then((res)=>{
                this.printData.deliverAddress = res.data.deliverAddress
                this.printData.deliverContact = res.data.deliverContact
                this.printData.deliverMobile = res.data.deliverMobile
                this.printData.printTitle = res.data.printTitle
            })
        },

        // 获取showShop
        getShowShop(){
            get('/mall/shop/getShowShop').then((res)=>{
                if(res.success){
                    this.showShop = res.showShop
                }
            })
        },

        // 补打小票
        printOrder(id){
            get('/shop/order/printOrder',{
                id:id
            }).then((res)=>{
                this.$message({
                    message: res.msg,
                    type:'success',
                    duration: 2000
                });
            })
        }
    }
};
</script>

<style lang="scss" scoped>
@page {
    size: auto;
    margin: 0mm;
}
.content{
    background-color: #fff;
    padding: 10px;
    height: 100%;
}
.page-content{
    height: 93%;
    padding: 0;
    border: 0;
}

.ReturnProcess {
    background-color: #f6f6f6;
    padding: 10px 10px;
    margin: 10px auto;
    border-radius: 4px;
}
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.afterRecord {
    height: 500px;
    overflow: auto;
    font-size: 12px;
}
.sum {
    margin-left: 10px;
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #606266;
}
.shop_mess {
    margin-left: 20px;
}
.look_over {
    position: absolute;
    right: 20px;
}
.state {
    position: absolute;
    right: 120px;
}
.shop_info {
    display: flex;
    align-items: center;
}
.arr {
    background-color: #409eff;
}
.chack {
    position: absolute;
    right: 180px;
}
.top_info {
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.peops {
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: row-reverse;
}
.cen_info {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
}
.top_title {
    width: 100%;
    display: flex;
    justify-content: center;
}
.top_span {
    text-align: center;
    width: 230px;
    margin: 0 auto;
    padding-bottom: 5px;
    border-bottom: 1px solid #000000;
}
.top_span1 {
    width: 100%;
    margin: 0 auto;
    font-size: 25px;
    border-bottom: 1px solid #000000;
}
.top_mess {
    margin-top: 40px;
}
.form_list {
    width: 745px;
    margin: 0 auto;
    // .el-table {
    //     border-bottom: 1px solid black;
    //     border-right: 1px solid black;
    //     margin: 0 auto;
    // }
    // ::v-deep.el-table th {
    //     border: 1px solid black;
    //     border-right: none ;
    //     border-bottom: none ;
    // }

    // ::v-deep.el-table td {
    //     border: 1px solid black;
    //     border-right: none ;
    // }
    .el-table {
        border-bottom: 1px solid black;
        border-right: 1px solid black;
        margin: 0 auto;
    }
    ::v-deep.el-table th {
        border: 1px solid black;
        border-right: none !important;
        border-bottom: none !important;
    }

    ::v-deep.el-table td {
        border: 1px solid black;
        border-right: none;
    }
    ::v-deep.el-table__cell:nth-child(2) {
        border-right-width: 0px !important;
    }
    ::v-deep.el-table__cell:nth-child(3) {
        border-right-width: 0px !important;
    }
    ::v-deep.el-table__cell:nth-child(4) {
        border-right-width: 0px !important;
    }
}

.people_list {
    margin-top: 20px;
}

/*显示底部边框 估计打印时伪元素把border覆盖了 height设为0隐藏伪元素*/
.el-table::before {
    height: 0;
}

/*显示右边框*/ //el-table__footer-wrapper   el-table__footer   has-gutter
.el-table--group::after,
.el-table--border::after {
    width: 0;
}
// .listTime {
//     // position: relative;
//     // left: 70%;
// }
::v-deep .el-table__footer-wrapper {
    .el-table__footer {
        .has-gutter {
            .el-table__cell:nth-child(2) {
                border-right-width: 0px !important;
            }
            .el-table__cell:nth-child(3) {
                border-right-width: 0px !important;
            }
            .el-table__cell:nth-child(4) {
                border-right-width: 0px !important;
            }
        }
    }
}

.el-table {
    color: #202124;
}

.el-table th {
    font-weight: normal;
}

.info_center {
    font-size: 24px;
    color: #202124;
    font-family: 宋体;
    font-weight: 750;
}
// ::v-deep .shopinft {
//     .el-table__cell {
//         padding: 0 !important;
//     }
// .el-table {
// margin-top: 0;
// }
// }
::v-deep .shopinft {
    .el-table {
        margin-top: 0 !important;
    }
}
// ::v-deep .el-table {
//     margin-top: 0 !important;
// }
// ::v-deep .right-content .el-table--border, .el-table--group {
//     border: 1px solid #be2222!important; #dae1f3
// }
::v-deep .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #d5d9e2;
}
::v-deep .temp {
    padding: 16px 0;
    .has-gutter {
        display: none;
    }
    .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
        border-bottom: 0;
    }
}
// ::v-deep .has-gutter{
//     display: none;
// }

.customer{
    width: 90%;
    margin: 0 auto;
    display: flex;
    margin-top: 15px;

    font-size: 15px;
    color: #202124;
    font-family: 宋体;
    font-weight: 500;

    .customer-left{
        flex: 3;
    }
    .customer-right{
        flex: 2;
        padding-left: 50px;
    }
}

.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
}
.el-icon-arrow-down {
    font-size: 12px;
}
.demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
}
::v-deep .el-dropdown{
    font-size: 12px;
    color: #409eff;
}

.deliver-box{
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .deliver-item{
        width: 280px;
        height: 30px;
        padding-left: 10px;
        display: flex;
        align-items: center;
    }
}

</style>
